/**
 * AUTO-GENERATED — node scripts/buildGnkProjectSeed.js
 * GNK 사업 flat 행 (1101건)
 * levels: 정책 15 · 단위 24 · 세부 1062
 *
 * 코드: 정책(01) > 단위(0101) > 세부(0101001)
 */
export const GNK_PROJECT_ROWS = [
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "01",
    "projectName": "폭력 및 학대로부터의 보호",
    "abbrName": "폭력 및 학대로",
    "finalYn": "N",
    "sortOrder": 10
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "01",
    "projectCode": "0101",
    "projectName": "학대피해아동 보호 및 예방",
    "abbrName": "학대피해아동 보",
    "finalYn": "N",
    "sortOrder": 20
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101001",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 30
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101002",
    "projectName": "학대피해아동 보호 및 예방-SOL Guard(신한금융그룹)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 40
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101003",
    "projectName": "학대피해아동 보호 및 예방-학대피해아동지원사업(코스트코코리아)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 50
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101004",
    "projectName": "학대피해아동보호 및 예방-i-CARE 아이케어 (현대자동차그룹)",
    "abbrName": "학대피해아동보호",
    "finalYn": "Y",
    "sortOrder": 60
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101005",
    "projectName": "학대피해아동보호 및 예방-희망봄프로젝트(SBI저축은행)",
    "abbrName": "학대피해아동보호",
    "finalYn": "Y",
    "sortOrder": 70
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101006",
    "projectName": "학대피해아동 보호 및 예방-위기가정 재기지원사업(신한금융그룹)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 80
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101007",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(홀트아동복지회 우리가족 마음이음)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 90
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101008",
    "projectName": "강원사회복지공동모금회-아동청소년 돌봄강화 프로그램(학대피해아동 보호 및 예방)",
    "abbrName": "강원사회복지공동",
    "finalYn": "Y",
    "sortOrder": 100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101009",
    "projectName": "학대피해아동 보호 및 예방-SOL Guard(신한금융그룹,4차년도)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101010",
    "projectName": "학대피해아동보호및예방-SOL Mate 4차(신한은행)",
    "abbrName": "학대피해아동보호",
    "finalYn": "Y",
    "sortOrder": 120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101011",
    "projectName": "학대피해아동 보호 및 예방-학대피해아동 청소년 가족기능강화사업(구로희망복지재단)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101012",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(학대피해아동 청소년 가족기능강화사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101013",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(AL♥YOU 프로젝트)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101014",
    "projectName": "학대예방사업(여성가장 긴급지원사업)",
    "abbrName": "학대예방사업(여",
    "finalYn": "Y",
    "sortOrder": 160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101015",
    "projectName": "학대피해아동보호및예방-이주배경청소년지원사업(강원사회복지공동모금회)",
    "abbrName": "학대피해아동보호",
    "finalYn": "Y",
    "sortOrder": 170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101016",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(국제로타리 3670지구)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101017",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(지파운데이션 심리치료지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101018",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(바보의 나눔 cpbc라디오지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101019",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(여성가장긴급지원사업)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101020",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(전북청년경제인협회 학대피해아동가정지원)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101021",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(가정지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101022",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(빈곤방임아동지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101023",
    "projectName": "학대피해아동보호및예방-아주특별한하루사업(좋은이웃후원회)",
    "abbrName": "학대피해아동보호",
    "finalYn": "Y",
    "sortOrder": 250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101024",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(생명나눔실천본부 치료비지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101025",
    "projectName": "학대피해아동 보호 및 예방-주거환경개선사업(홀트아동복지회)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101026",
    "projectName": "학대피해아동 보호 및 예방-(주)DSC 아산공장 기탁 학대피해아동 및 시설보호아동 가족친화사업(충남사회복지공동모금회)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101027",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(희망둥지SOS위기아동가정긴급지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101028",
    "projectName": "학대피해아동 보호 및 예방-아주복지재단 위기아동청소년 지원사업(아주복지재단)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101029",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(내생애최고의날)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101030",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(가족기능강화)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101031",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(의사회가 밝히는 꿈의 등불 장학 사업)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101032",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(사랑밭 위기가정지원사업)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101033",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(PHC 학대피해아동 미래성장지원 사업)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101034",
    "projectName": "학대피해아동 보호 및 예방-학대피해아동 가정지원사업(삼성디스플레이, 충남일자리경제진흥원 외)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101035",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업-국내 긴급위기지원 사례(개인후원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101036",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(윤성빈)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101037",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(이관우 다시 이음)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101038",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(부산지방우정청)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101039",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (국내 학대피해아동 및 가정역량강화지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101040",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(감성스피치 심리서비스지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101041",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(치과의사회 심리서비스지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101042",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(심리치료 및 심리정서지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101043",
    "projectName": "학대예방사업(조기개입지원)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101044",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(겨울방학 반찬지원 '아늑한끼')",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101045",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(새학기 나눔키트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101046",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(\"작은 도화지 위에 그린 가족 행복 Day \" 우리가족행복키트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101047",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(정O빈 외 1 가정 지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101048",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(다시, 아이답게)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101049",
    "projectName": "학대예방사업",
    "abbrName": "학대예방사업",
    "finalYn": "Y",
    "sortOrder": 510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101050",
    "projectName": "학대피해아동 보호체계 지원사업(SOL 동전기부)-신한은행",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101051",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(VANNER와 함께하는 아동지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101052",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업-2025년 기능보강(강원사회복지공동모금회)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101053",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(키다리아저씨사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101054",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(금쪽같은우리가족)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101055",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(슬기로운 나눔생활)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101056",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(좋은이웃후원회)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101057",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(심리검사 및 치료 6차년도 상반기)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101058",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(코스트코코리아 6차년도 하반기)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101059",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2025 국립중앙청소년수련원 후원금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101060",
    "projectName": "학대피해아동 보호체계지원사업(i CARE 아이케어 3차년도)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101061",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2025년 신청사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101062",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2025 비지정후원금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101063",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2차년도 한미반도체)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101064",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(희망봄프로젝트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101065",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(대전사회복지공동모금회 학대피해아동 심리건강 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101066",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(학대피해아동 및 가족 심리·정서 지원 사업 마음 온(溫))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101067",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(학대피해아동가정지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101068",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(우리가족 함께해봄)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101069",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(시설입소아동지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101070",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(학대피해아동 및 긴급위기 아동지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101071",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2025 삼성나눔키오스크)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101072",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(여성가장 긴급지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101073",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(위기가정 및 취약계층 대상 주방용품 지원사업 '주방의 히어로')",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101074",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(굿러너컴퍼니)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101075",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (위기가정 반찬지원 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101076",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(위기가정사례지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101077",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(GN명절키트 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101078",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(국내긴급위기사례지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101079",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(SOS위고)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101080",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(바보의나눔 여성가장긴급지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101081",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(신한위기가정지원사업7차년도 35차)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101082",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(EX누리보듬)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101083",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사례지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101084",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (경기사회복지공동모금회 심리정서지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101085",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (설맞이 새해 희망키트 배분사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101086",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(천사들의 일일찻집)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101087",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (삼성전기(주) 나눔키오스크)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101088",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(아동심리정서지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101089",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(엄마도 아이도 온전한 세상)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101090",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(조손가정 난방비 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101091",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(심리서비스지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101092",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (지역사회조직)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101093",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(국제로타리클럽 3750지구 심리치료 및 심리정서지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101094",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(온기드림 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101095",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(마음UP!성장UP!)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101096",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(오거리사랑요양병원 후원을 통한 장학금 지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101097",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사례지원-한*빈 지정후원금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101098",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사례지원-한*빈 )",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101099",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(생계비 지원-이레에스아이)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101100",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(방학 중 취약계층 아동 반찬지원 사업 뚜밥)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101101",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(의료비 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101102",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(희망 Up! 행복 Up!)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101103",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(위기가정사례 지원 사업비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101104",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(청소년 암예방 \"Happy Virus\" 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101105",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(LGD 세이프티넷-아동보호통합지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101106",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(우리가족 울타리 이음)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101107",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(GM과 함께하는 아동학대예방을 위한 AR교육지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101108",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(GM과 함께하는 학대피해아동 지원을 위한 '마음응급상자')",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101109",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(시설아동지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101110",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(심리치료 및 가정지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101111",
    "projectName": "학대예방사업(아이온)",
    "abbrName": "학대예방사업(아",
    "finalYn": "Y",
    "sortOrder": 1130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101112",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(코스트코코리아 7차년도 상반기)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101113",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(SOL Guard, 5차년도)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101114",
    "projectName": "학대피해아동 보호체계지원사업(SOL Mate 5차)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 1160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101115",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(따소비 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101116",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(전문상담 및 치료사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101117",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(의료비 지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101118",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(무지개사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101119",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(반짝이는 꿈, 그리고 우리)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101120",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(마음ON프로젝트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101121",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(새마을금고와 함께하는 우리동네아동지킴이)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101122",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(대전사회복지공동모금회-금성백조(가정역량강화 맞춤형 지원사업))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101123",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(경성대 장학금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101124",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(위기가정지원 의료비 지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101125",
    "projectName": "학대피해아동 회복 및 가정역량강회지원사업(LGU+ 천원의사랑)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101126",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (돌봄취약가정 대상 화재경보기 및 소화패치 보급 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101127",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(\"시원한 여름나기 나눔사업\" 목포역 한국철도공사)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101128",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(전문상담 및 치료사업-공동모금회)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101129",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(LS그룹과 함께하는 학대피해아동가정 지원 및 고위험가정 가족기능강화사업[Sharing of Love(6차년도)])",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101130",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(대명복지재단-가족캠프)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101131",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(공부방 및 주택개보수지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101132",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(롯데카드 러브팩토리)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101133",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(온(溫)맘 키트사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101134",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(저소득가정지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101135",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (마음건강지킴이 Good Friend 3차)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101136",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (코레일유통(주) 여름용품 배분사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101137",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (광교꿈의교회 취약계층아동 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101138",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (홀트아동복지회 주거환경개선사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101139",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (삼성임직원 아동지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101140",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2025년 아주복지재단 위기아동청소년지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101141",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(위기가정아동긴급지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101142",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2025 삼성 나눔 키오스크)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101143",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (삼성전기(주) 나눔키오스크 어린이날 선물지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101144",
    "projectName": "학대예방사업(가온누리)",
    "abbrName": "학대예방사업(가",
    "finalYn": "Y",
    "sortOrder": 1460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101145",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(우리가족 울타리이음)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101146",
    "projectName": "학대피해아동 보호체계지원사업(i CARE 아이케어 3차년도-1)",
    "abbrName": "학대피해아동 보",
    "finalYn": "Y",
    "sortOrder": 1480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101147",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(심리치료 인프라 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101148",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (함께하는 사랑밭 위기가정 희망지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101149",
    "projectName": "학대예방사업(The울타리-공동모금회 '25-'27 아동 청소년의 보호 및 자립을 위한 맞춤형 지원사업)",
    "abbrName": "학대예방사업(T",
    "finalYn": "Y",
    "sortOrder": 1510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101150",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(상담자의 숨돌리기-공동모금회 사회복지 종사자 삶의 질 향상과 근로환경 개선을 위한 맞춤형 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101151",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(아산사회복지재단 SOS 복지지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101152",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2025년 5차 복지현안우선지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101153",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업('한가위' 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101154",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(노아투어-가족캠프지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101155",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (좋은이웃후원회와 함께하는 굿무브)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101156",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(우리가족더풍성하게추석KIT)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101157",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(CPBC라디오지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101158",
    "projectName": "학대피해아동 회복 및 가족역량강화지원사업(한국도로공사 서산아산건설사업단)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101159",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(겨울나기 방한용품)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101160",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(크리스마스 가정 지원 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101161",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(국민연금공단 목포지사)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101162",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(목포혜인여자중학교 기부미(寄府美, give-美))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101163",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사례지원-이*람)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101164",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(아동·청소년 동절기 의류 지원사업 '겨울에 온(溫) 마음, 또 하나의 온기')",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101165",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (한국지역난방공사 학교폭력 예방교육 및 심리정서지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101166",
    "projectName": "학대예방사업(수원대학교 공공정책대학원 조기개입 지원사업)",
    "abbrName": "학대예방사업(수",
    "finalYn": "Y",
    "sortOrder": 1680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101167",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 ((재)바보의나눔 여성가장 긴급지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101168",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (코레일유통(주) 겨울용품 배분사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101169",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (삼성전기(주) 나눔키오스크 크리스마스 선물지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101170",
    "projectName": "학대예방사업(2025 위기가정대상 조기지원사업)",
    "abbrName": "학대예방사업(2",
    "finalYn": "Y",
    "sortOrder": 1720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101171",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(한가정지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101172",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(홀트아동복지회 우리가족 울타리이음)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101173",
    "projectName": "학대예방사업(조기개입지원사업 우리가족 소행성)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 1750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101174",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(드림메이트-강원사회복지공동모금회 진로 인프라 취약지역 아동·청소년의 자기 주도적 진로 탐색을 위한 지역사회 연계 꿈 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101175",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(다(多)가치 한끼)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101176",
    "projectName": "학대예방사업(조기개입지원사업 - 핵심사업 비지정)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 1780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101177",
    "projectName": "학대예방사업(조기개입지원사업 - in 군산)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 1790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101178",
    "projectName": "학대예방사업(조기개입지원사업 - with together)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 1800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101179",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(마음 잇기)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101180",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(일반사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101181",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(도비보조금(인건비))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101182",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(시비보조금(회계감사수수료))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101183",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(시비보조금(건강검진비))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101184",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(시비보조금(시설장관리업무수당))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101185",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(경상보조금(한시인력))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101186",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(호봉제(추가))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101187",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(호봉제 차액 보전금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101188",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(하이아이/정읍시)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101189",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(처우개선&임차료)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101190",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(종사자특별수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101191",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(포항/인건비 및 종사자수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101192",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(포항/운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101193",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(포항/복지포인트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101194",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(포항/방문형)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101195",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(청송/인건비 및 종사자수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101196",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(청송/운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101197",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(청송/방문형)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 1990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101198",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(잡수입/인건비 및 종사자수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101199",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(잡수입/운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101200",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(잡수입/아동학대예방사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101201",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(잡수입/복지포인트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101202",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(잡수입/방문형)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101203",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(울진/인건비 및 종사자수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101204",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(울진/운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101205",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(울진/방문형)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101206",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(울릉/인건비 및 종사자수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101207",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(울릉/운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101208",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(울릉/방문형)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101209",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(영덕/인건비 및 종사자수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101210",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(영덕/운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101211",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(영덕/방문형)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101212",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(아동학대예방사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101213",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(도비보조금(시간외근무수당))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101214",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(초과근무수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101215",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(아동친화도시(기타보조금))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101216",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(도비보조금(추가인건비))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101217",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(경기도 추가인력 인건비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101218",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(추가인건비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101219",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(심리치료추가지원비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101220",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(보조금(심리치료·검사))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101221",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(보조금(시흥시 복지포인트))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101222",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(방문형가정회복프로그램)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101223",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(명절수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101224",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(기타보조금사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101225",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(조기개입지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101226",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(기능보강사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101227",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(가족수당)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101228",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사회복지카드)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101229",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사업지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101230",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101231",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(이월 및 잡수입)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101232",
    "projectName": "학대예방사업(조기개입지원사업)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 2340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101233",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(희망봄 프로젝트 6차)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101234",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(SOL Mate 6차)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101235",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(i CARE 아이케어 4차)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101236",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(코스트코코리아 8차 상반기)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 2380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101237",
    "projectName": "학대피해아동회복 및 가정역량강화지원사업(코스트코코리아 7차 하반기)",
    "abbrName": "학대피해아동회복",
    "finalYn": "Y",
    "sortOrder": 2390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101238",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(홈케어플래너서포터즈)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101239",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(아동심리정서지원-원광대학교 글로컬사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101240",
    "projectName": "학대예방사업(빈곤방임아동지원사업)",
    "abbrName": "학대예방사업(빈",
    "finalYn": "Y",
    "sortOrder": 2420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101241",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(피해아동 가정 지원 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101242",
    "projectName": "학대예방사업(함께하는 사랑밭)",
    "abbrName": "학대예방사업(함",
    "finalYn": "Y",
    "sortOrder": 2440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101243",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(좋은이웃후원회 기관환경개선지원사업))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101244",
    "projectName": "학대에방사업(하이,아이지원사업-운영비)",
    "abbrName": "학대에방사업(하",
    "finalYn": "Y",
    "sortOrder": 2460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101245",
    "projectName": "학대예방사업(하이,아이지원사업-가족기능회복형)",
    "abbrName": "학대예방사업(하",
    "finalYn": "Y",
    "sortOrder": 2470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101246",
    "projectName": "학대예방사업(하이,아이지원사업-신속지원)",
    "abbrName": "학대예방사업(하",
    "finalYn": "Y",
    "sortOrder": 2480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101247",
    "projectName": "학대예방사업 (군산시 부모학교사업)",
    "abbrName": "학대예방사업 (",
    "finalYn": "Y",
    "sortOrder": 2490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101248",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (아동학대예방사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101249",
    "projectName": "학대예방사업 (아동학대예방사업)",
    "abbrName": "학대예방사업 (",
    "finalYn": "Y",
    "sortOrder": 2510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101250",
    "projectName": "학대예방사업(좋은이웃후원회)",
    "abbrName": "학대예방사업(좋",
    "finalYn": "Y",
    "sortOrder": 2520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101251",
    "projectName": "학대예방사업(비지정후원금)",
    "abbrName": "학대예방사업(비",
    "finalYn": "Y",
    "sortOrder": 2530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101252",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(지역사회네트워크사업비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101253",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(한국전력공사(해외사업개발단)와 함께하는 쑥쑥 새학기 안전 플러스(+) KIT 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101254",
    "projectName": "학대예방사업 (조기개입지원사업-세이프스타트 in 서울)",
    "abbrName": "학대예방사업 (",
    "finalYn": "Y",
    "sortOrder": 2560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101255",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(새학기 새싹키트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101256",
    "projectName": "학대예방사업(2026년 아동학대예방‧조기개입지원사업 「ON:U(온:유)」)",
    "abbrName": "학대예방사업(2",
    "finalYn": "Y",
    "sortOrder": 2580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101257",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(추가 난방비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101258",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(복지포인트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101259",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(밀알복지재단)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101260",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(리본 프로젝트)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101261",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(26년 학대피해아동 사례지원/박O환)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101262",
    "projectName": "지역유치기금(학대피해아동 지원 및 예방사업)",
    "abbrName": "지역유치기금(학",
    "finalYn": "Y",
    "sortOrder": 2640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101263",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(국내위기가정 주거기능보강사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101264",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(함께하는 사랑밭 위기가정 희망지원사업(희망이음 결연지원))",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101265",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(이랜드복지재단 SOS위고)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101266",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(학대피해아동의 심리치료 환경개선을 위한 기능보강 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101267",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(학대트라우마 회복지원 RE:CARE)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101268",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(개인여아결연사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101269",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(보물보따리)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101270",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(YS김안과)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101271",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(스텝온)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101272",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (우리가족을 지켜주세요)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101273",
    "projectName": "학대예방사업(충남사회복지공동모금회 소통의 온도)",
    "abbrName": "학대예방사업(충",
    "finalYn": "Y",
    "sortOrder": 2750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101274",
    "projectName": "학대예방사업(굿네이버스 위기가정지원사업)",
    "abbrName": "학대예방사업(굿",
    "finalYn": "Y",
    "sortOrder": 2760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101275",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(우리가족 마음이음사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101276",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(저소득가정 아동 성장키트 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101277",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(위기가정 명절 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101278",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (삼성전기(주) 나눔키오스크 선물후원사업 2026년)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101279",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (사회복지공동모금회 황태환아너 기탁성금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101280",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (사회복지공동모금회 삼성전자3어린이집 기탁성금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101281",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (삼성전기(주) 나눔키오스크 2026년)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101282",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(의왕도시공사 가족기능강화사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101283",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(청계자유발도르프학교 개별상담 및 치료사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101284",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(한가정행복만들기)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101285",
    "projectName": "학대예방사업(조기개입지원 with 좋은이웃후원회)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 2870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101286",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(주거환경개선 with 전북대학교병원 간호사회)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101287",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(기관운영지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101288",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(연세대학교-행복한 우리가족 봄 KIT)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101289",
    "projectName": "학대예방사업(온가람)",
    "abbrName": "학대예방사업(온",
    "finalYn": "Y",
    "sortOrder": 2910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101290",
    "projectName": "학대예방사업(양성평등기금사업)",
    "abbrName": "학대예방사업(양",
    "finalYn": "Y",
    "sortOrder": 2920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101291",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(든든한 한 끼, 자라나는 온기)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101292",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(다시 찾는 건강, 활기찬 미소)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101293",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(직원슈퍼비전 지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101294",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(토닥토닥, 우리 가족 마음 이음)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101295",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(일상의 쉼표, 든든한 채움)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101296",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(반짝반짝, 다시 찾은 일상의 빛)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101297",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(함께 걷는 발걸음, 엄마의 내일)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 2990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101298",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(포근한 우리 집, 안전한 보금자리)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101299",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(KBS강태원복지재단-위기가정 지원 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101300",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(든든한 동행, 따뜻함을 전하는 마음)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101301",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(걸음기부)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101302",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(취약가정 반찬지원사업 ''온기가득 밥상'')",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101303",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(장애아동 재활치료비 지원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101304",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업 (학대피해아동 주거환경개선 사업 '우리가족 울타리이음' )",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101305",
    "projectName": "학대예방사업(연세대학교-조기개입지원)",
    "abbrName": "학대예방사업(연",
    "finalYn": "Y",
    "sortOrder": 3070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101306",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(방학중 위기가정아동 돌봄공백 및 결식지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101307",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(스마트워크지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101308",
    "projectName": "학대피해아동 회복 및 가정역략강화지원사업(양성평등기금사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101309",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(따소비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101310",
    "projectName": "학대예방사업(조기개입지원사업-바보의나눔)",
    "abbrName": "학대예방사업(조",
    "finalYn": "Y",
    "sortOrder": 3120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101311",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(2026년 아주복지재단 위기아동청소년지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101312",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(인천사회복지공동모금회 2026년 하나금융지주 지정기탁사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101313",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(부모성장자조모임지원사업-부모피움)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101314",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(조은안과와 굿네이버스 강원남부지부가 함께하는 ‘2026년 강원FC 홈경기 관람 지원사업')",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101315",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(국내위기가정사례지원-사단법인 굿네이버스)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101316",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(또하나의가족)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101317",
    "projectName": "학대예방사업(허그맘허그인심리상담센터-조기개입지원)",
    "abbrName": "학대예방사업(허",
    "finalYn": "Y",
    "sortOrder": 3190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101318",
    "projectName": "학대예방사업(서울탑정신과의원-조기개입지원)",
    "abbrName": "학대예방사업(서",
    "finalYn": "Y",
    "sortOrder": 3200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101319",
    "projectName": "학대예방사업(다담심리상담센터-조기개입지원)",
    "abbrName": "학대예방사업(다",
    "finalYn": "Y",
    "sortOrder": 3210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101320",
    "projectName": "학대예방사업(온맘심리상담센터-조기개입지원)",
    "abbrName": "학대예방사업(온",
    "finalYn": "Y",
    "sortOrder": 3220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101321",
    "projectName": "학대예방사업(아동학대예방 조기지원사업-포항시의사회)",
    "abbrName": "학대예방사업(아",
    "finalYn": "Y",
    "sortOrder": 3230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101322",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사회복지시설 에너지효율사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101323",
    "projectName": "학대예방사업(우리집에 찾아온 봄)",
    "abbrName": "학대예방사업(우",
    "finalYn": "Y",
    "sortOrder": 3250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101324",
    "projectName": "학대예방사업(한국지엠(주) 보령사업본부-다(多)가치)",
    "abbrName": "학대예방사업(한",
    "finalYn": "Y",
    "sortOrder": 3260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101325",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(추가 냉방비)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101326",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(결식아동 후원)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101327",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(삼성전기 나눔가게 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101328",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(코레일유통 취약계층 여름용품 지원사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101329",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(사회복지공동모금회 서울88의원 기탁성금)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101330",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(보현보살장학회 장학금 사업)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101331",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(새봄(새만금과 함께 돌보는) 방학교실)",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0101",
    "projectCode": "0101332",
    "projectName": "학대피해아동 회복 및 가정역량강화지원사업(신우이엠주식회사 재능장학 지원사업 '꿈사다리')",
    "abbrName": "학대피해아동 회",
    "finalYn": "Y",
    "sortOrder": 3340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "01",
    "projectCode": "0102",
    "projectName": "가정보호 및 대안양육 지원",
    "abbrName": "가정보호 및 대",
    "finalYn": "N",
    "sortOrder": 3350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102001",
    "projectName": "가정형보호지원사업",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102002",
    "projectName": "보호아동지원사업(GN세이프가드 굿키즈)",
    "abbrName": "보호아동지원사업",
    "finalYn": "Y",
    "sortOrder": 3370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102003",
    "projectName": "가정보호 및 대안양육 지원-월동난방비지원사업(공동모금회)",
    "abbrName": "가정보호 및 대",
    "finalYn": "Y",
    "sortOrder": 3380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102004",
    "projectName": "가정보호 및 대안양육 지원- 보호아동 지원(네이버 해피빈)",
    "abbrName": "가정보호 및 대",
    "finalYn": "Y",
    "sortOrder": 3390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102005",
    "projectName": "보호아동지원사업(범죄피해자지원센터)",
    "abbrName": "보호아동지원사업",
    "finalYn": "Y",
    "sortOrder": 3400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102006",
    "projectName": "가정보호 및 대안양육 지원- 보호아동 지원(김O영 후원자)",
    "abbrName": "가정보호 및 대",
    "finalYn": "Y",
    "sortOrder": 3410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102007",
    "projectName": "가정보호 및 대안양육지원-SOL Guard(신한금융그룹,4차년도)",
    "abbrName": "가정보호 및 대",
    "finalYn": "Y",
    "sortOrder": 3420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102008",
    "projectName": "가정형보호지원사업(Dream Up Project)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102009",
    "projectName": "가정형보호지원사업(위탁아동결연지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102010",
    "projectName": "가정형보호지원사업(나눔 키오스크 26차 사례)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102011",
    "projectName": "가정형보호지원사업(스마일하우스)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102012",
    "projectName": "가정형보호지원사업(아동 개별지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102013",
    "projectName": "가정형보호지원사업(위탁부모소진예방지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102014",
    "projectName": "가정형보호지원사업 (2025년 학대피해아동 보호시설 지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102015",
    "projectName": "가정형보호지원사업 (전국학아협 개인후원자 연계사업-아동사업비)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102016",
    "projectName": "가정형보호지원사업(2025년 학대피해아동 보호시설 쉼터(그룹홈) 지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102017",
    "projectName": "가정형보호지원사업(학대피해아동의 심신 건강을 위한 통합케어서비스 사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102018",
    "projectName": "가정형보호지원사업(학대피해아동 보호시설 지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102019",
    "projectName": "가정형보호지원사업(피복비 지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102020",
    "projectName": "가정형보호지원사업(시설운영비 지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102021",
    "projectName": "가정형보호지원사업(사례지원-신0현)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102022",
    "projectName": "가정형보호지원사업(사례지원-김0영)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102023",
    "projectName": "가정형보호지원사업(사례지원-강0훈)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102024",
    "projectName": "가정형보호지원사업(2025년 아동-원가족 가족역량강화서비스)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102025",
    "projectName": "가정형보호지원사업 (마음건강지킴이 Good Friend 3차)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102026",
    "projectName": "가정형보호지원사업(범죄피해자지원센터-보호아동지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102027",
    "projectName": "가정형보호지원사업(복지현안우선지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102028",
    "projectName": "가정형보호지원사업(환경개선 지원사업-푸르니존)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102029",
    "projectName": "가정형보호지원사업(원주시의회-보호아동지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102030",
    "projectName": "가정형보호지원사업(국민건강보험공단-보호아동지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102031",
    "projectName": "가정형보호지원사업(지역사회네트워크-울타리기도회)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102032",
    "projectName": "가정형보호지원사업(MBC 지금은 라디오시대 학대피해아동지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102033",
    "projectName": "가정형보호지원사업(롯데카드 러브팩토리 캠페인-신0서)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102034",
    "projectName": "가정형보호지원사업(학대피해아동 심리정서 회복지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102035",
    "projectName": "가정형보호지원사업(위탁가정역량강화지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102036",
    "projectName": "가정보호지원사업(일시보호시설아동 초기적응지원사업 따뜻한첫걸음키트)",
    "abbrName": "가정보호지원사업",
    "finalYn": "Y",
    "sortOrder": 3710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102037",
    "projectName": "가정형보호지원사업(꿈디딤돌 장학지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102038",
    "projectName": "가정형보호지원사업(학대피해아동협회비)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102039",
    "projectName": "가정형보호지원사업(무궁화복지월드)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102040",
    "projectName": "가정형보호지원사업(대한아동학대방지협회)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102041",
    "projectName": "가정형보호지원사업(CMS집금)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102042",
    "projectName": "가정형보호지원사업(차량비지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102043",
    "projectName": "가정형보호지원사업(자산취득비지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102044",
    "projectName": "가정형보호지원사업(사회복지종사자 지원사업)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102045",
    "projectName": "가정형보호지원사업(보호아동 지원)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102046",
    "projectName": "가정형보호지원사업((위탁부모역량강화) 위탁부모 힐링캠프)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102047",
    "projectName": "보호아동지원사업",
    "abbrName": "보호아동지원사업",
    "finalYn": "Y",
    "sortOrder": 3820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102048",
    "projectName": "보호아동지원사업(일반사업)",
    "abbrName": "보호아동지원사업",
    "finalYn": "Y",
    "sortOrder": 3830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102049",
    "projectName": "보호아동지원사업(일반사업(보장시설수급자 생계비))",
    "abbrName": "보호아동지원사업",
    "finalYn": "Y",
    "sortOrder": 3840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102050",
    "projectName": "가정형보호지원사업(가정위탁 생활비지원사업-품안보듬)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102051",
    "projectName": "가정형보호지원사업(삼성나눔키오스크 35차-이0영)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102052",
    "projectName": "지역유치기금(보호아동지원사업)",
    "abbrName": "지역유치기금(보",
    "finalYn": "Y",
    "sortOrder": 3870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102053",
    "projectName": "가정형보호지원사업(국내위기가정사례지원(PMS)-강0정)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102054",
    "projectName": "보호아동지원사업(경계선지능인 역량지원사업 성장형 학습자 : 슬기로운 성장생활)",
    "abbrName": "보호아동지원사업",
    "finalYn": "Y",
    "sortOrder": 3890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102055",
    "projectName": "가정형보호지원사업(국내위기가정사례지원(PMS)-이0영)",
    "abbrName": "가정형보호지원사",
    "finalYn": "Y",
    "sortOrder": 3900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0102",
    "projectCode": "0102056",
    "projectName": "보호아동지원사업(평원중학교)",
    "abbrName": "보호아동지원사업",
    "finalYn": "Y",
    "sortOrder": 3910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "02",
    "projectName": "위기가정 지원과 불평등 감소",
    "abbrName": "위기가정 지원과",
    "finalYn": "N",
    "sortOrder": 3920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "02",
    "projectCode": "0201",
    "projectName": "위기가정아동 돌봄 및 지원",
    "abbrName": "위기가정아동 돌",
    "finalYn": "N",
    "sortOrder": 3930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201001",
    "projectName": "위기가정아동 돌봄사업",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 3940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201002",
    "projectName": "위기가정아동 긴급 지원-그외사업캠페인(온라인캠페인)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 3950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201003",
    "projectName": "위기가정아동 긴급 지원-사례지원(온라인캠페인)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 3960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201004",
    "projectName": "위기가정아동긴급지원-삼성나눔위크사례지원사업(삼성EPC)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 3970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201005",
    "projectName": "위기가정아동 긴급 지원-특별회원기금 사례지원",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 3980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201006",
    "projectName": "위기가정아동 긴급 지원-기업기금 사례지원",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 3990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201007",
    "projectName": "위기가정아동 긴급 지원-나눔키오스크사업(삼성메디슨)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201008",
    "projectName": "위기가정 긴급 지원-나눔의날(삼성전자)",
    "abbrName": "위기가정 긴급 ",
    "finalYn": "Y",
    "sortOrder": 4010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201009",
    "projectName": "위기가정아동 지원사업(삼성전자 키오스크사업)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201010",
    "projectName": "위기가정아동 지원사업(삼성 SDI 키오스크사업)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201011",
    "projectName": "위기가정아동 긴급지원-가족 돌봄 청소년(영케어러) 자립 지원 사업 'Dear young'(현대카드 신용카드사회공헌재단)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201012",
    "projectName": "위기가정아동 긴급 지원-위기가정 재기지원사업(신한금융그룹)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201013",
    "projectName": "위기가정아동 긴급 지원-사시수술지원사업(밝은안과21병원)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201014",
    "projectName": "위기가정아동 긴급 지원-좋은이웃후원회 '위기가정지원사업'(좋은이웃후원회)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201015",
    "projectName": "위기가정아동긴급지원-학대피해아동지원사업(원웨이영어학원)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201016",
    "projectName": "위기가정아동긴급지원-학대피해아동지원사업(보물보따리)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201017",
    "projectName": "위기가정아동긴급지원-학대피해아동지원사업(YS김안과)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201018",
    "projectName": "위기가정아동긴급지원-학대피해아동지원사업(한국도로공사)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201019",
    "projectName": "위기가정아동 긴급 지원-여성가장지원(바보의나눔)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201020",
    "projectName": "위기가정아동 긴급 지원-여성가장 긴급지원사업((재)바보의나눔))",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201021",
    "projectName": "위기가정아동 긴급지원-은평구 취약계층아동 지원프로그램(아소비교육)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201022",
    "projectName": "위기가정아동 긴급지원-가족역량지원사업(강동구지역사회보장협의체)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201023",
    "projectName": "위기가정아동 긴급 지원-24년 기획 냉난방비 지원사업(광주사회복지공동모금회)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201024",
    "projectName": "위기가정아동지원사업(국내위기가정아동 사례지원-김O영 후원자)",
    "abbrName": "위기가정아동지원",
    "finalYn": "Y",
    "sortOrder": 4170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201025",
    "projectName": "위기가정아동긴급지원-SOL Guard(신한금융그룹,4차년도)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201026",
    "projectName": "위기가정아동 긴급지원-환자치료비 지원 대상자 지원금(생명나눔실천본부)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201027",
    "projectName": "위기가정아동 긴급지원-운영비(진*문 외 1명)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201028",
    "projectName": "위기가정아동 긴급 지원 - 키오스크사업(세이브더칠드런)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201029",
    "projectName": "위기가정아동 긴급지원-위기가정대상 조기지원사업(스토브리코리아)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201030",
    "projectName": "위기가정아동 지원사업-여아지원사업 '긴급사례지원'",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201031",
    "projectName": "위기가정아동 긴급 지원-학대피해아동지원사업 6차년도 상반기(코스트코코리아)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201032",
    "projectName": "위기가정아동 긴급지원-(21차)신한위기가정재기지원(신한은행)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201033",
    "projectName": "위기가정아동 긴급지원-아름다운 사랑 아름다운 나눔(바보의나눔)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201034",
    "projectName": "위기가정아동 긴급지원-학대피해아동 및 취약계층 지원사업(일동제약)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201035",
    "projectName": "위기가정아동긴급지원-희망둥지 SOS 해피빈 의료비 지원 사업(기아대책)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201036",
    "projectName": "위기가정아동긴급지원(삼성나눔의날사례지원사업)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201037",
    "projectName": "위기가정아동 긴급지원사업(긴급사례지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201038",
    "projectName": "위기가정아동 지원사업(펀디자인 운영지원)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201039",
    "projectName": "위기가정아동 긴급지원사업(학대피해아동 장학금 지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201040",
    "projectName": "위기가정아동 긴급지원사업(학대피해아동 장학금 지원)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201041",
    "projectName": "위기가정아동 긴급지원사업(주거환경개선비)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201042",
    "projectName": "위기가정아동 긴급지원사업(삼성나눔키오스크)-삼성EPC",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201043",
    "projectName": "위기가정아동 긴급지원사업(가족 돌봄 청소년(영케어러) 자립 지원 사업 'Dear young')-현대카드 신용카드사회공헌재단",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201044",
    "projectName": "위기가정아동 긴급지원사업(가족돌봄 청소년(영케어러) 자립 지원 사업 'Dear young' 2차)-신용카드사회공헌재단(현대카드)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201045",
    "projectName": "위기가정아동 긴급지원사업(국내긴급위기가정 사례지원사업_특후기금)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201046",
    "projectName": "위기가정아동긴급지원(삼성나눔키오스크)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201047",
    "projectName": "위기가정아동 긴급지원사업(조손가정 난방비 지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201048",
    "projectName": "위기가정아동 지원사업(삼성전자 볼런테인먼트)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201049",
    "projectName": "위기가정아동 긴급지원사업(삼성 나눔의날 및 키오스크 사례지원)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201050",
    "projectName": "위기가정아동 지원사업(삼성전자·경북사회복지공동모금회 나눔 키오스크)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201051",
    "projectName": "위기가정아동긴급지원사업(하이,아이지원-운영비)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201052",
    "projectName": "위기가정아동긴급지원(하이,아이지원-가족기능회복형)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201053",
    "projectName": "위기가정아동긴급지원사업(하이,아이지원-신속지원)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201054",
    "projectName": "위기가정아동 긴급지원사업(SOS위고)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201055",
    "projectName": "위기가정아동 긴급지원(2025년 신청사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201056",
    "projectName": "위기가정아동 긴급지원사업(여성가장 긴급지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201057",
    "projectName": "위기가정아동 돌봄사업(저소득가정 아동 지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 4500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201058",
    "projectName": "위기가정아동 긴급지원사업(2025년 신한위기가정 재기지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201059",
    "projectName": "위기가정아동 긴급지원사업(비지정후원금)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201060",
    "projectName": "위기가정아동 긴급지원사업(아산재단 SOS사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201061",
    "projectName": "위기가정아동 긴급지원사업(골든타임-공동모금회 복지현안우선지원사업 2차)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201062",
    "projectName": "위기가정아동 긴급지원사업(국내긴급위기사례지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201063",
    "projectName": "위기가정아동 긴급지원사업(맞춤형 사례지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201064",
    "projectName": "위기가정아동 지원사업(지역사회 내 아동 나눔 캠페인 '활력 한 끼')",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201065",
    "projectName": "위기가정아동지원사업(지역사회 내 취약계층 대상 여가활동 지원사업 'Water+Full Day')",
    "abbrName": "위기가정아동지원",
    "finalYn": "Y",
    "sortOrder": 4580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201066",
    "projectName": "위기가정아동 긴급지원사업(굿러너컴퍼니)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201067",
    "projectName": "위기가정아동 긴급지원사업(함께하는 사랑밭)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201068",
    "projectName": "위기가정아동 긴급지원사업(GN세이프스타트)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201069",
    "projectName": "위기가정아동 긴급지원사업(GN위기가정 조기지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201070",
    "projectName": "위기가정아동 지원사업(LGD세이프티넷-화재취약마을 화재예방지원)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201071",
    "projectName": "위기가정아동 긴급지원사업(경북지역아동센터협의회 산불 피해 복구 지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201072",
    "projectName": "위기가정아동 지원사업(원익큐엔씨 화재예방지원 안전첫걸음)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201073",
    "projectName": "위기가정아동 지원사업(2025 삼성 키오스크 사례지원)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201074",
    "projectName": "위기가정아동 긴급지원사업(2025년 함께모아행복금고 연합모금사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201075",
    "projectName": "위기가정아동 긴급지원사업(35차 신한위기가정지원)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201076",
    "projectName": "위기가정아동 지원사업(삼성E&A, 삼성물산(주), 삼성중공업(주) 나눔키오스크)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201077",
    "projectName": "위기가정아동긴급지원사업 (삼성전기(주) 나눔키오스크 어린이날 선물지원사업)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201078",
    "projectName": "위기가정아동긴급지원사업 (삼성전기(주) 나눔키오스크 )",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201079",
    "projectName": "위기가정아동 지원사업(1월 국내 위기가정지원 캠페인 '아픈 아빠의 가난한 육아')",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201080",
    "projectName": "위기가정아동 긴급지원사업(지역특성화사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201081",
    "projectName": "위기가정아동 긴급지원사업(삼성전자 산불피해지원)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201082",
    "projectName": "위기가정아동 긴급지원사업(지역사회네트워크)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201083",
    "projectName": "위기가정아동 돌봄사업(가정지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 4760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201084",
    "projectName": "위기가정아동 돌봄사업(공연및행사)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 4770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201085",
    "projectName": "위기가정아동 긴급지원사업(자산취득비)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201086",
    "projectName": "위기가정아동 긴급지원사업(운영비)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201087",
    "projectName": "위기가정아동 긴급지원사업(해피빈 환경개선사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201088",
    "projectName": "위기가정아동 긴급지원사업(LS일렉트릭과 함께하는 꿈드림키트지원사업 'Let's Start Together')",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201089",
    "projectName": "위기가정아동 긴급지원사업(2025년 국내 위기사례 긴급지원 사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201090",
    "projectName": "위기가정아동긴급지원(다자녀다함께행복프로젝트)",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201091",
    "projectName": "위기가정아동긴급지원(고립, 은둔 청소년의 서비스 지원을 통한 생계비 지원 사업 'RE:CONNECT')",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201092",
    "projectName": "위기가정아동 긴급지원사업(의료비지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201093",
    "projectName": "위기가정아동 긴급지원사업(포스코 퓨처엠 환경개선사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201094",
    "projectName": "위기가정아동 긴급지원사업(무지개사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201095",
    "projectName": "위기가정아동 긴급지원사업 (띄움프로젝트)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201096",
    "projectName": "위기가정아동 긴급지원사업(GGM 프로젝트)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201097",
    "projectName": "위기가정아동 긴급지원사업(희망장학금 두드림)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201098",
    "projectName": "위기가정아동 긴급지원사업(2025년 복권기금 아동청소년 돌봄강화 프로그램)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201099",
    "projectName": "위기가정아동 긴급 지원(희망둥지 SOS 위기아동가정긴급지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201100",
    "projectName": "위기가정아동 긴급지원사업(대전사회복지공동모금회-금성백조(가족역량강화 맞춤형 지원사업))",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201101",
    "projectName": "위기가정아동 지원사업(좋은이웃후원회)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 4940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201102",
    "projectName": "위기가정아동 긴급지원사업(2025년 국내 긴급 위기사례 지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201103",
    "projectName": "위기가정아동 긴급지원사업(조기개입지원-좋은이웃후원회(대전지부))",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201104",
    "projectName": "위기가정아동 긴급지원사업(기아대책_기대드림)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201105",
    "projectName": "위기가정아동 긴급지원사업(조기개입지원-공동모금회)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 4980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201106",
    "projectName": "위기가정아동긴급지원사업(LS그룹과 함께하는 학대피해아동가정 지원 및 고위험가정 가족기능강화사업[Sharing of Love(6차년도)])",
    "abbrName": "위기가정아동긴급",
    "finalYn": "Y",
    "sortOrder": 4990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201107",
    "projectName": "위기가정아동 긴급지원(저소득가정 아동 성장키트 지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201108",
    "projectName": "위기가정아동 지원사업(국내위기가정사례지원-엔*오)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201109",
    "projectName": "위기가정아동 긴급지원사업(조기개입지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201110",
    "projectName": "위기가정아동 지원사업(국내위기가정지원사업)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201111",
    "projectName": "위기가정아동 긴급지원사업(조기개입지원-포항시의사회)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201112",
    "projectName": "위기가정아동 긴급지원사업(우리가족 울타리이음)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201113",
    "projectName": "위기가정아동 긴급 지원사업(25년 기획 냉난방비 지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201114",
    "projectName": "위기가정아동 긴급지원사업(함께하는 사랑밭 위기가정 희망지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201115",
    "projectName": "위기가정아동 긴급지원사업(교원인연사랑캠페인 심리정서지원사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201116",
    "projectName": "위기가정아동 긴급지원사업(기아대책 환경개선사업)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201117",
    "projectName": "위기가정아동 긴급지원사업(k-water)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201118",
    "projectName": "위기가정아동 긴급지원사업(바보의 나눔)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201119",
    "projectName": "위기가정아동 긴급지원사업(2025년 조기개입지원사업 '우리 가족 안전 플러스 키트')",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201120",
    "projectName": "위기가정아동 긴급지원사업(2025 희망친구 기아대책 '잇다')",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201121",
    "projectName": "위기가정아동 지원사업(Dear young 3차년도)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201122",
    "projectName": "위기가정아동 긴급지원(여아긴급사례지원)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201123",
    "projectName": "위기가정아동 긴급지원사업(세이브더칠드런 난방용품지원)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201124",
    "projectName": "위기가정아동 긴급지원사업(따뜻한 수(水) 나눔)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201125",
    "projectName": "위기가정아동 긴급지원사업(도레이첨단소재중합팀 교육장학금)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 5180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201126",
    "projectName": "위기가정아동 지원사업",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201127",
    "projectName": "위기가정아동 돌봄사업(종사자 상해보험료)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201128",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 특화프로그램(교육발전 특별교부금))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201129",
    "projectName": "위기가정아동 돌봄사업(일반사업(시비추가운영비))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201130",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 특수목적형추가지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201131",
    "projectName": "위기가정아동 돌봄사업(문화체험활동비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201132",
    "projectName": "위기가정아동 돌봄사업(돌봄교사지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201133",
    "projectName": "위기가정아동 돌봄사업(정서함양비사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201134",
    "projectName": "위기가정아동 돌봄사업(하계수련비사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201135",
    "projectName": "위기가정아동 돌봄사업(종사자건강검진비지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201136",
    "projectName": "위기가정아동 돌봄사업(물품구입비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201137",
    "projectName": "위기가정아동 돌봄사업(환경개선지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201138",
    "projectName": "위기가정아동 돌봄사업(등하원안심알림이지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201139",
    "projectName": "위기가정아동 돌봄사업(우수지역아동센터 운영지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201140",
    "projectName": "위기가정아동 돌봄사업(교재교구비사업(2020년포괄사업비))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201141",
    "projectName": "위기가정아동 돌봄사업(비품구입비사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201142",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 간식비 지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201143",
    "projectName": "위기가정아동 돌봄사업(관리자수당 추가지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201144",
    "projectName": "위기가정아동 돌봄사업(문예지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201145",
    "projectName": "위기가정아동 돌봄사업(인권전문가수당)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201146",
    "projectName": "위기가정아동 돌봄사업(간식비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201147",
    "projectName": "위기가정아동 돌봄사업(꿈드림 교실)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201148",
    "projectName": "위기가정아동 돌봄사업(현장체험학습비(시비))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201149",
    "projectName": "위기가정아동 돌봄사업(현장체험학습비(도비))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201150",
    "projectName": "위기가정아동 돌봄사업(돌봄교사보조금(355-0034-0754-03))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201151",
    "projectName": "위기가정아동 돌봄사업(환경개선비보조금(351-1137-9650-43))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201152",
    "projectName": "위기가정아동 돌봄사업(보험가입비보조금(351-1138-2834-33))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201153",
    "projectName": "위기가정아동 돌봄사업(아동친화특화마을사업운영비-'아동권리모니터링단')",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201154",
    "projectName": "위기가정아동 돌봄사업(공공운영비 지원금)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201155",
    "projectName": "위기가정아동 돌봄사업(기타사업비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201156",
    "projectName": "위기가정아동 돌봄사업(교육복지우선지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201157",
    "projectName": "위기가정아동 돌봄사업(북구청사업비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201158",
    "projectName": "위기가정아동 돌봄사업(다센터법인지원금)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201159",
    "projectName": "위기가정아동 돌봄사업(냉난방비 추가지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201160",
    "projectName": "위기가정아동 돌봄사업(냉난방비지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201161",
    "projectName": "위기가정아동 돌봄사업(특화프로그램비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201162",
    "projectName": "위기가정아동 돌봄사업(정액급식비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201163",
    "projectName": "위기가정아동 돌봄사업(휴일급식비보조금)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201164",
    "projectName": "위기가정아동 돌봄사업(추가급식비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201165",
    "projectName": "위기가정아동 돌봄사업(급식비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201166",
    "projectName": "위기가정아동 돌봄사업(단일임금)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201167",
    "projectName": "위기가정아동 돌봄사업(명절휴가비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201168",
    "projectName": "위기가정아동 돌봄사업(종사자맞춤형복지포인트)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201169",
    "projectName": "위기가정아동 돌봄사업(종사자복지포인트)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201170",
    "projectName": "위기가정아동 돌봄사업(종사자자격수당)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201171",
    "projectName": "위기가정아동 돌봄사업(종사자수당)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201172",
    "projectName": "위기가정아동 돌봄사업(종사자처우개선비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201173",
    "projectName": "위기가정아동 돌봄사업(인건비(호봉제))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201174",
    "projectName": "위기가정아동 돌봄사업(인건비(정액제))",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201175",
    "projectName": "위기가정아동 돌봄사업(일반사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201176",
    "projectName": "위기가정아동 돌봄사업(추가인건비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201177",
    "projectName": "위기가정아동 돌봄사업(추가운영비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201178",
    "projectName": "위기가정아동 돌봄사업(기본인건비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201179",
    "projectName": "위기가정아동 돌봄사업(기본운영비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201180",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 종사자 복지포인트)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201181",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 조리사인건비 지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201182",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 냉난방비 지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201183",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 인건비 지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201184",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 기본운영비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201185",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 추가운영비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201186",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 특화프로그램 지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201187",
    "projectName": "위기가정아동 돌봄사업(지역아동센터 인건비 추가지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201188",
    "projectName": "위기가정아동 돌봄사업(특수목적형 지역아동센터 추가운영비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201189",
    "projectName": "위기가정아동 돌봄사업(토요운영 지역아동센터 추가운영비)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201190",
    "projectName": "위기가정아동 돌봄사업(아동보호지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201191",
    "projectName": "위기가정아동 지원사업(맞춤형 사례지원사업 2차)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201192",
    "projectName": "위기가정아동 지원사업(KB금융그룹 야간연장돌봄)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201193",
    "projectName": "위기가정아동 지원사업(위기 결식아동영양지원사업)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201194",
    "projectName": "위기가정아동 지원사업(SK실트론·경북사회복지공동모금회 행복드림)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201195",
    "projectName": "지역유치기금(아동돌봄 및 위기가정지원사업)",
    "abbrName": "지역유치기금(아",
    "finalYn": "Y",
    "sortOrder": 5880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201196",
    "projectName": "위기가정아동 돌봄사업(지역사회조직-지역사회네트워크)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201197",
    "projectName": "위기가정아동 돌봄사업(문화지원사업-체험활동)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201198",
    "projectName": "위기가정아동 돌봄사업(CJ도너스캠프문화제안사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201199",
    "projectName": "위기가정아동 지원사업(원익큐엔씨 안전키트지원사업)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201200",
    "projectName": "위기가정아동 돌봄사업(물품구입비사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201201",
    "projectName": "위기가정아동 돌봄사업(종사자인건비추가지원사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201202",
    "projectName": "위기가정아동 돌봄사업(틈새돌봄사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201203",
    "projectName": "위기가정아동 지원사업(도레이첨단소재중합팀 조사연구사업)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201204",
    "projectName": "위기가정아동 지원사업(안덕마실애마을학교)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 5970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201205",
    "projectName": "위기가정아동 돌봄사업(해피빈 학습지도)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201206",
    "projectName": "위기가정아동 돌봄사업(성모병원 가정지원)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 5990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201207",
    "projectName": "위기가정아동 지원사업(삼성전자 나눔 키오스크-특별모금)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 6000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201208",
    "projectName": "위기가정아동 지원사업(삼성전자 나눔가게)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 6010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201209",
    "projectName": "위기가정아동 지원사업(054플리마켓 054공방)",
    "abbrName": "위기가정아동 지",
    "finalYn": "Y",
    "sortOrder": 6020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0201",
    "projectCode": "0201210",
    "projectName": "위기가정아동 돌봄사업(공동모금회 지정기탁사업)",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 6030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "03",
    "projectName": "건강하고 행복한 삶",
    "abbrName": "건강하고 행복한",
    "finalYn": "N",
    "sortOrder": 6040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "03",
    "projectCode": "0301",
    "projectName": "신체건강 지원",
    "abbrName": "신체건강 지원",
    "finalYn": "N",
    "sortOrder": 6050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301001",
    "projectName": "아동의료지원사업",
    "abbrName": "아동의료지원사업",
    "finalYn": "Y",
    "sortOrder": 6060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301002",
    "projectName": "신체건강 지원-여아캠페인(온라인캠페인)",
    "abbrName": "신체건강 지원-",
    "finalYn": "Y",
    "sortOrder": 6070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301003",
    "projectName": "신체건강지원-여아지원사업 '빛나는 너의 날'(롯데칠성)",
    "abbrName": "신체건강지원-여",
    "finalYn": "Y",
    "sortOrder": 6080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301004",
    "projectName": "여아지원사업(여아위생용품지원사업, 서연화)",
    "abbrName": "여아지원사업(여",
    "finalYn": "Y",
    "sortOrder": 6090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301005",
    "projectName": "신체건강지원-아산시 취약계층여아지원사업(공동모금회)",
    "abbrName": "신체건강지원-아",
    "finalYn": "Y",
    "sortOrder": 6100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301006",
    "projectName": "신체건강지원-SOL Guard(신한금융그룹,4차년도)",
    "abbrName": "신체건강지원-S",
    "finalYn": "Y",
    "sortOrder": 6110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301007",
    "projectName": "신체건강 지원-JB와 열여덟 함께서기 시즌2 의료비(전북은행)",
    "abbrName": "신체건강 지원-",
    "finalYn": "Y",
    "sortOrder": 6120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301008",
    "projectName": "신체건강 지원-자립준비청년 의료비 지원사업(사단법인굿네이버스)",
    "abbrName": "신체건강 지원-",
    "finalYn": "Y",
    "sortOrder": 6130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301009",
    "projectName": "아동 영양발달지원사업(첫참잘했어요)",
    "abbrName": "아동 영양발달지",
    "finalYn": "Y",
    "sortOrder": 6140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301010",
    "projectName": "여아지원사업(여아청소년 키트&장학지원)",
    "abbrName": "여아지원사업(여",
    "finalYn": "Y",
    "sortOrder": 6150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301011",
    "projectName": "여아지원사업(소녀생각KIT)",
    "abbrName": "여아지원사업(소",
    "finalYn": "Y",
    "sortOrder": 6160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301012",
    "projectName": "아동건강증진사업(아이들의 굿-건강 그루브)",
    "abbrName": "아동건강증진사업",
    "finalYn": "Y",
    "sortOrder": 6170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301013",
    "projectName": "여아지원사업",
    "abbrName": "여아지원사업",
    "finalYn": "Y",
    "sortOrder": 6180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301014",
    "projectName": "아동건강증진사업",
    "abbrName": "아동건강증진사업",
    "finalYn": "Y",
    "sortOrder": 6190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301015",
    "projectName": "여아지원사업(꿈꾸는소녀)-F&F",
    "abbrName": "여아지원사업(꿈",
    "finalYn": "Y",
    "sortOrder": 6200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301016",
    "projectName": "여아지원사업(해삐소녀키트)",
    "abbrName": "여아지원사업(해",
    "finalYn": "Y",
    "sortOrder": 6210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301017",
    "projectName": "여아지원사업(꿈꾸는 소녀)-F&F",
    "abbrName": "여아지원사업(꿈",
    "finalYn": "Y",
    "sortOrder": 6220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301018",
    "projectName": "여아지원사업(여아지원사업)-현대카드",
    "abbrName": "여아지원사업(여",
    "finalYn": "Y",
    "sortOrder": 6230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301019",
    "projectName": "아동 체력증진사업(더 좋은 지원 시즌3)",
    "abbrName": "아동 체력증진사",
    "finalYn": "Y",
    "sortOrder": 6240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301020",
    "projectName": "아동 체력증진사업(2025년 포스코 지정기탁사업-포스코 드림하이)",
    "abbrName": "아동 체력증진사",
    "finalYn": "Y",
    "sortOrder": 6250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301021",
    "projectName": "여아지원사업(세아제강 세아별프로젝트)",
    "abbrName": "여아지원사업(세",
    "finalYn": "Y",
    "sortOrder": 6260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301022",
    "projectName": "여아지원사업(beyoutiful)",
    "abbrName": "여아지원사업(b",
    "finalYn": "Y",
    "sortOrder": 6270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301023",
    "projectName": "아동 체력증진사업(2025년 포항시 농어촌 지역의 저소득층 아동을 위한 놀이 지원 사업)",
    "abbrName": "아동 체력증진사",
    "finalYn": "Y",
    "sortOrder": 6280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301024",
    "projectName": "아동 영양발달지원사업 (NH투자증권 결식아동영양지원사업 '따뜻한 채움')",
    "abbrName": "아동 영양발달지",
    "finalYn": "Y",
    "sortOrder": 6290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301025",
    "projectName": "여아지원사업(2025년 복권기금 아동·청소년 돌봄강화 프로그램 '지켜줄게, 빛나줄래?')",
    "abbrName": "여아지원사업(2",
    "finalYn": "Y",
    "sortOrder": 6300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301026",
    "projectName": "아동 체력증진사업(좋은이웃후원회와 함께하는 굿무브)",
    "abbrName": "아동 체력증진사",
    "finalYn": "Y",
    "sortOrder": 6310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301027",
    "projectName": "아동 체력증진사업(조은안과와 굿네이버스 강원남부지부가 함께하는 ‘2025년 강원FC 홈경기 관람 지원사업')",
    "abbrName": "아동 체력증진사",
    "finalYn": "Y",
    "sortOrder": 6320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301028",
    "projectName": "아동체력증진사업(마음ON프로젝트)",
    "abbrName": "아동체력증진사업",
    "finalYn": "Y",
    "sortOrder": 6330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301029",
    "projectName": "아동건강증진사업(더불어돌봄(THE봄)사업)",
    "abbrName": "아동건강증진사업",
    "finalYn": "Y",
    "sortOrder": 6340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301030",
    "projectName": "아동건강증진사업(LIG넥스원 방학 중 급식 지원사업 '행복도시락')",
    "abbrName": "아동건강증진사업",
    "finalYn": "Y",
    "sortOrder": 6350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301031",
    "projectName": "아동영양발달지원사업(맛있는 하루 요리교실-크래프트하인즈코리아)",
    "abbrName": "아동영양발달지원",
    "finalYn": "Y",
    "sortOrder": 6360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301032",
    "projectName": "아동 체력증진사업 (삼성전기 나눔키오스크)",
    "abbrName": "아동 체력증진사",
    "finalYn": "Y",
    "sortOrder": 6370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301033",
    "projectName": "아동체력증진사업(몸을 움직여봐)(몸을 움직여봐)",
    "abbrName": "아동체력증진사업",
    "finalYn": "Y",
    "sortOrder": 6380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301034",
    "projectName": "여아지원사업(소녀의 Moon)",
    "abbrName": "여아지원사업(소",
    "finalYn": "Y",
    "sortOrder": 6390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301035",
    "projectName": "아동건강증진사업(아동들의 굿-건강 그루브)",
    "abbrName": "아동건강증진사업",
    "finalYn": "Y",
    "sortOrder": 6400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301036",
    "projectName": "여아지원사업(취약계층 여아지원사업 2차)",
    "abbrName": "여아지원사업(취",
    "finalYn": "Y",
    "sortOrder": 6410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301037",
    "projectName": "아동의료지원사업(지역사회 내 아동 건강권 증진사업 ‘Health Right+’)",
    "abbrName": "아동의료지원사업",
    "finalYn": "Y",
    "sortOrder": 6420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301038",
    "projectName": "지역유치기금(아동건강권증진사업)",
    "abbrName": "지역유치기금(아",
    "finalYn": "Y",
    "sortOrder": 6430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301039",
    "projectName": "아동건강증진사업(세아제강 영양키트지원사업)",
    "abbrName": "아동건강증진사업",
    "finalYn": "Y",
    "sortOrder": 6440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301040",
    "projectName": "여아지원사업(셀럭스 건강관리지원사업)",
    "abbrName": "여아지원사업(셀",
    "finalYn": "Y",
    "sortOrder": 6450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0301",
    "projectCode": "0301041",
    "projectName": "아동건강증진사업(스마일ON)",
    "abbrName": "아동건강증진사업",
    "finalYn": "Y",
    "sortOrder": 6460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "03",
    "projectCode": "0302",
    "projectName": "마음건강 지원",
    "abbrName": "마음건강 지원",
    "finalYn": "N",
    "sortOrder": 6470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302001",
    "projectName": "마음건강증진지원사업",
    "abbrName": "마음건강증진지원",
    "finalYn": "Y",
    "sortOrder": 6480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302002",
    "projectName": "마음건강지원-사례지원(온라인캠페인)",
    "abbrName": "마음건강지원-사",
    "finalYn": "Y",
    "sortOrder": 6490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302003",
    "projectName": "마음건강지원-마음건강 지원사업 마음건강지킴이 'Good Friend'(F&F)",
    "abbrName": "마음건강지원-마",
    "finalYn": "Y",
    "sortOrder": 6500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302004",
    "projectName": "마음건강지원-특별회원기금 사례지원",
    "abbrName": "마음건강지원-특",
    "finalYn": "Y",
    "sortOrder": 6510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302005",
    "projectName": "마음건강지원-학대피해아동 및 가정 역량강화사업 (한미)",
    "abbrName": "마음건강지원-학",
    "finalYn": "Y",
    "sortOrder": 6520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302006",
    "projectName": "마음건강 지원-희망봄프로젝트(SBI저축은행)",
    "abbrName": "마음건강 지원-",
    "finalYn": "Y",
    "sortOrder": 6530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302007",
    "projectName": "마음건강지원-희망ON학교(BMW)",
    "abbrName": "마음건강지원-희",
    "finalYn": "Y",
    "sortOrder": 6540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302008",
    "projectName": "마음건강지원-다함께행복ON(BMW)",
    "abbrName": "마음건강지원-다",
    "finalYn": "Y",
    "sortOrder": 6550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302009",
    "projectName": "마음건강지원-내 마음을 피자!(BMW)",
    "abbrName": "마음건강지원-내",
    "finalYn": "Y",
    "sortOrder": 6560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302010",
    "projectName": "마음건강지원-우리가족 마음이음(홀트아동복지회)",
    "abbrName": "마음건강지원-우",
    "finalYn": "Y",
    "sortOrder": 6570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302011",
    "projectName": "마음건강지원-꿈 베이스 3차년도(KGC)",
    "abbrName": "마음건강지원-꿈",
    "finalYn": "Y",
    "sortOrder": 6580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302012",
    "projectName": "마음건강지원-마음건강 지원사업 마음건강지킴이 'Good Friend 2차'(F&F)",
    "abbrName": "마음건강지원-마",
    "finalYn": "Y",
    "sortOrder": 6590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302013",
    "projectName": "마음건강지원 - 마음터치(장인수회원)",
    "abbrName": "마음건강지원 -",
    "finalYn": "Y",
    "sortOrder": 6600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302014",
    "projectName": "마음건강지원-SOL Guard(신한금융그룹,4차년도)",
    "abbrName": "마음건강지원-S",
    "finalYn": "Y",
    "sortOrder": 6610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302015",
    "projectName": "마음건강 지원-학대피해아동 및 가정회복지원사업(위드병원)",
    "abbrName": "마음건강 지원-",
    "finalYn": "Y",
    "sortOrder": 6620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302016",
    "projectName": "마음건강지원-온(ON) 마음 사업(충남사회복지공동모금회)",
    "abbrName": "마음건강지원-온",
    "finalYn": "Y",
    "sortOrder": 6630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302017",
    "projectName": "마음건강 지원-학대피해아동지원사업 6차년도 상반기(코스트코코리아)",
    "abbrName": "마음건강 지원-",
    "finalYn": "Y",
    "sortOrder": 6640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302018",
    "projectName": "마음건강지원사업-학대피해아동 및 취약계층 지원사업(일동제약)",
    "abbrName": "마음건강지원사업",
    "finalYn": "Y",
    "sortOrder": 6650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302019",
    "projectName": "마음건강지원-심리치료지원 (김다현팬카페)",
    "abbrName": "마음건강지원-심",
    "finalYn": "Y",
    "sortOrder": 6660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302020",
    "projectName": "마음건강지원-심리치료지원 (광교꿈의교회)",
    "abbrName": "마음건강지원-심",
    "finalYn": "Y",
    "sortOrder": 6670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302021",
    "projectName": "마음건강지원-심리치료지원 (수원남부로타리클럽)",
    "abbrName": "마음건강지원-심",
    "finalYn": "Y",
    "sortOrder": 6680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302022",
    "projectName": "마음건강증진지원사업(우리들은 행복해 5차)",
    "abbrName": "마음건강증진지원",
    "finalYn": "Y",
    "sortOrder": 6690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302023",
    "projectName": "심리상담및전문치료지원사업(치료환경개선사업)",
    "abbrName": "심리상담및전문치",
    "finalYn": "Y",
    "sortOrder": 6700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302024",
    "projectName": "느린학습자지원사업(느린 걸음, 함께 성장)",
    "abbrName": "느린학습자지원사",
    "finalYn": "Y",
    "sortOrder": 6710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302025",
    "projectName": "느린학습자 지원사업",
    "abbrName": "느린학습자 지원",
    "finalYn": "Y",
    "sortOrder": 6720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302026",
    "projectName": "심리상담 및 전문치료지원사업",
    "abbrName": "심리상담 및 전",
    "finalYn": "Y",
    "sortOrder": 6730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302027",
    "projectName": "심리상담 및 전문치료지원사업(어린이병원 발달센터 치료프로그램 지원사업)-서울어린이병원",
    "abbrName": "심리상담 및 전",
    "finalYn": "Y",
    "sortOrder": 6740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302028",
    "projectName": "마음건강증진지원사업(다함께행복ON)",
    "abbrName": "마음건강증진지원",
    "finalYn": "Y",
    "sortOrder": 6750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302029",
    "projectName": "마음건강증진지원사업(성모병원 학습비가정지원사업)",
    "abbrName": "마음건강증진지원",
    "finalYn": "Y",
    "sortOrder": 6760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302030",
    "projectName": "마음건강증진지원사업(보호아동지원)",
    "abbrName": "마음건강증진지원",
    "finalYn": "Y",
    "sortOrder": 6770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302031",
    "projectName": "느린학습자지원사업(아동행복 PLUS 교실)",
    "abbrName": "느린학습자지원사",
    "finalYn": "Y",
    "sortOrder": 6780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302032",
    "projectName": "느린학습자지원사업(LG디스플레이)",
    "abbrName": "느린학습자지원사",
    "finalYn": "Y",
    "sortOrder": 6790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302033",
    "projectName": "느린학습자 지원사업(세방이의순재단)",
    "abbrName": "느린학습자 지원",
    "finalYn": "Y",
    "sortOrder": 6800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302034",
    "projectName": "마음건강증진지원사업(2026년 한전KPS(주)동해사업소와 함께하는 학대피해아동 심리·정서 지원사업「마음충전 프로젝트」)",
    "abbrName": "마음건강증진지원",
    "finalYn": "Y",
    "sortOrder": 6810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0302",
    "projectCode": "0302035",
    "projectName": "느린학습자지원사업(희망의 굿키즈)",
    "abbrName": "느린학습자지원사",
    "finalYn": "Y",
    "sortOrder": 6820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "03",
    "projectCode": "0303",
    "projectName": "아동친화적 환경, 인프라 개선",
    "abbrName": "아동친화적 환경",
    "finalYn": "N",
    "sortOrder": 6830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303001",
    "projectName": "아동 친화적 성장환경조성사업",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303002",
    "projectName": "기후위기대응사업",
    "abbrName": "기후위기대응사업",
    "finalYn": "Y",
    "sortOrder": 6850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303003",
    "projectName": "아동친화적환경, 인프라개선-사례지원(온라인캠페인)",
    "abbrName": "아동친화적환경,",
    "finalYn": "Y",
    "sortOrder": 6860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303004",
    "projectName": "아동친화적 환경 인프라개선-국공립어린이집 및 아이사랑꿈터 시설 지원사업(하나은행)",
    "abbrName": "아동친화적 환경",
    "finalYn": "Y",
    "sortOrder": 6870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303005",
    "projectName": "아동친화적 환경, 인프라 개선-농촌지역 학교 유휴공간 조성사업(NH농협금융)",
    "abbrName": "아동친화적 환경",
    "finalYn": "Y",
    "sortOrder": 6880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303006",
    "projectName": "아동친화적환경인프라개선-청소년 주거환경 개선사업(한국씨티은행)",
    "abbrName": "아동친화적환경인",
    "finalYn": "Y",
    "sortOrder": 6890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303007",
    "projectName": "아동친화적 환경, 인프라 개선-위기가정 재기지원사업(신한금융그룹)",
    "abbrName": "아동친화적 환경",
    "finalYn": "Y",
    "sortOrder": 6900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303008",
    "projectName": "아동친화적환경,인프라개선-지역아동센터 환경개선지원사업(우리카드-신용카드사회공헌재단)",
    "abbrName": "아동친화적환경,",
    "finalYn": "Y",
    "sortOrder": 6910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303009",
    "projectName": "아동 친화적 성장환경조성사업 (어린이병원 체육치료시설 조성사업)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303010",
    "projectName": "아동 친화적 성장환경조성사업(클린세이프티)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303011",
    "projectName": "아동양육 부모교육",
    "abbrName": "아동양육 부모교",
    "finalYn": "Y",
    "sortOrder": 6940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303012",
    "projectName": "아동 친화적 성장환경조성사업(청소년주거환경지원사업 2차)-한국씨티은행",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303013",
    "projectName": "아동 친화적 성장환경조성사업(우주공간 2차)-NH농협은행",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303014",
    "projectName": "아동 친화적 성장환경조성사업(지역아동센터 시설지원사업 3차)-하나금융나눔재단",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303015",
    "projectName": "아동 친화적 성장환경조성사업(국공립어린이집 및 아이사랑꿈터 시설지원사업 3차)-하나은행",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303016",
    "projectName": "아동 친화적 성장환경조성사업(어린이병원 가상현실 발달치료 놀이센터 조성사업)-서울어린이병원",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 6990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303017",
    "projectName": "아동 친화적 성장환경조성사업(농촌지역 학교 유휴공간 조성사업 1차)-NH농협은행",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303018",
    "projectName": "아동 친화적 성장환경조성사업(어려운 주거환경에 처해있는 청소년 지원사업 2차)-한국씨티은행",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303019",
    "projectName": "아동 친화적 성장환경조성사업(i CARE 아이케어 3차년도)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303020",
    "projectName": "아동 친화적 성장환경조성사업(yes! 키즈카페)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303021",
    "projectName": "아동 친화적 성장환경조성사업(KB국민은행노동조합 노조 사회적 책임(USR) 봉사활동)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303022",
    "projectName": "아동양육 부모교육사업(부모교육-아동권리증진을 위한 교육 및 참여활동사업(더욱 THE 반짝 PART2))",
    "abbrName": "아동양육 부모교",
    "finalYn": "Y",
    "sortOrder": 7050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303023",
    "projectName": "아동 친화적 성장환경조성사업(LG디스플레이 기후위기대응사업 좋은 이웃, 좋은 지구)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303024",
    "projectName": "아동 친화적 성장환경조성사업(문화예술지원사업 '학교폭력, 아동학대 없는 행복한 학교, 건강한 사회 만들기' 미술 공모전)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303025",
    "projectName": "아동 친화적 성장환경조성사업(아지트)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303026",
    "projectName": "아동 친화적 성장환경조성사업(주거환경개선 사업)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303027",
    "projectName": "아동 친화적 성장환경조성사업(공부방 및 주택개보수지원사업)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303028",
    "projectName": "아동 친화적 성장환경조성사업(LGD 세이프티넷-교통안전용품지원)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303029",
    "projectName": "아동 친화적 성장환경조성사업(LGD 세이프티넷-교통환경개선지원)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303030",
    "projectName": "아동 친화적 성장환경조성사업(우리가족 울타리이음)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303031",
    "projectName": "아동 친화적 성장환경조성사업(위기아동지원사업)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303032",
    "projectName": "아동 친화적 성장환경조성사업(보듬자리)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303033",
    "projectName": "디지털아동권리증진사업",
    "abbrName": "디지털아동권리증",
    "finalYn": "Y",
    "sortOrder": 7160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303034",
    "projectName": "아동 친화적 성장환경 조성사업(i CARE 아이케어 4차)",
    "abbrName": "아동 친화적 성",
    "finalYn": "Y",
    "sortOrder": 7170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303035",
    "projectName": "아동양육 부모교육(일반사업)",
    "abbrName": "아동양육 부모교",
    "finalYn": "Y",
    "sortOrder": 7180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303036",
    "projectName": "아동양육 부모교육(아동학대예방사업)",
    "abbrName": "아동양육 부모교",
    "finalYn": "Y",
    "sortOrder": 7190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0303",
    "projectCode": "0303037",
    "projectName": "아동양육부모교육사업 (아동학대예방사업)",
    "abbrName": "아동양육부모교육",
    "finalYn": "Y",
    "sortOrder": 7200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "04",
    "projectName": "미래성장과 자립 지원",
    "abbrName": "미래성장과 자립",
    "finalYn": "N",
    "sortOrder": 7210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "04",
    "projectCode": "0401",
    "projectName": "미래성장 지원",
    "abbrName": "미래성장 지원",
    "finalYn": "N",
    "sortOrder": 7220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401001",
    "projectName": "미래성장지원사업",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401002",
    "projectName": "미래성장지원-사례지원(온라인캠페인)",
    "abbrName": "미래성장지원-사",
    "finalYn": "Y",
    "sortOrder": 7240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401003",
    "projectName": "미래성장지원-드림하이7차(신용카드사회공헌재단)",
    "abbrName": "미래성장지원-드",
    "finalYn": "Y",
    "sortOrder": 7250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401004",
    "projectName": "미래성장지원-드림블루밍(삼덕회계법인)",
    "abbrName": "미래성장지원-드",
    "finalYn": "Y",
    "sortOrder": 7260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401005",
    "projectName": "미래성장지원-2024 학업장학사업(우리다문화장학재단)",
    "abbrName": "미래성장지원-2",
    "finalYn": "Y",
    "sortOrder": 7270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401006",
    "projectName": "미래성장지원-특별회원기금 사례지원",
    "abbrName": "미래성장지원-특",
    "finalYn": "Y",
    "sortOrder": 7280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401007",
    "projectName": "미래성장 지원-에듀케어존(골프존)",
    "abbrName": "미래성장 지원-",
    "finalYn": "Y",
    "sortOrder": 7290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401008",
    "projectName": "미래성장지원-가족 돌봄 청소년(영케어러) 자립 지원 사업 'Dear young'(현대카드 신용카드사회공헌재단)",
    "abbrName": "미래성장지원-가",
    "finalYn": "Y",
    "sortOrder": 7300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401009",
    "projectName": "미래성장지원-아동역량강화지원사업(UPS)",
    "abbrName": "미래성장지원-아",
    "finalYn": "Y",
    "sortOrder": 7310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401010",
    "projectName": "미래성장지원-JB 희망의 학습멘토링 2기(전북은행)",
    "abbrName": "미래성장지원-J",
    "finalYn": "Y",
    "sortOrder": 7320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401011",
    "projectName": "미래성장지원-교육봉사 연계형 장학사업(한국지역난방공사)",
    "abbrName": "미래성장지원-교",
    "finalYn": "Y",
    "sortOrder": 7330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401012",
    "projectName": "미래성장지원-다함께행복ON(BMW)",
    "abbrName": "미래성장지원-다",
    "finalYn": "Y",
    "sortOrder": 7340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401013",
    "projectName": "미래성장지원-꿈 베이스 3차년도(KGC)",
    "abbrName": "미래성장지원-꿈",
    "finalYn": "Y",
    "sortOrder": 7350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401014",
    "projectName": "미래성장지원-동전기부 2분기 아동양육시설 아동권리옹호 합창단 지원사업(신한은행)",
    "abbrName": "미래성장지원-동",
    "finalYn": "Y",
    "sortOrder": 7360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401015",
    "projectName": "미래성장지원-은평구 취약계층아동 지원프로그램(아소비교육)",
    "abbrName": "미래성장지원-은",
    "finalYn": "Y",
    "sortOrder": 7370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401016",
    "projectName": "인재육성 미래성장지원사업(시설아동-성로원)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401017",
    "projectName": "미래성장지원- 지역아동센터 초등부 아동의 1인 1재능을 위한 '오카리나'프로그램 사업\"(두산에너빌리티)",
    "abbrName": "미래성장지원- ",
    "finalYn": "Y",
    "sortOrder": 7390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401018",
    "projectName": "미래성장 지원-SOL Guard(신한금융그룹,4차년도)",
    "abbrName": "미래성장 지원-",
    "finalYn": "Y",
    "sortOrder": 7400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401019",
    "projectName": "미래성장 지원-With 우리 드림 up 프로젝트(우리금융그룹)",
    "abbrName": "미래성장 지원-",
    "finalYn": "Y",
    "sortOrder": 7410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401020",
    "projectName": "미래성장지원사업- UOB대화은행 서울지점과 함께하는 초중학교 취약계층 예체는 특기생지원사업(UOB대화은행)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401021",
    "projectName": "미래성장지원사업-학대피해아동 및 취약계층 지원사업(일동제약)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401022",
    "projectName": "인재육성 미래성장지원사업(2025 겨울 다다캠프-중등)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401023",
    "projectName": "미래성장지원사업(유소년 배구 꿈나무 지원사업)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401024",
    "projectName": "아동 문화예술지원사업(성동좋은이웃지역아동센터 문화체험지원)",
    "abbrName": "아동 문화예술지",
    "finalYn": "Y",
    "sortOrder": 7460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401025",
    "projectName": "인재육성 미래성장지원사업(가정위탁아동예비자립학교)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401026",
    "projectName": "미래성장지원사업(대학생장학지원사업)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401027",
    "projectName": "미래성장지원(드림하이8차)",
    "abbrName": "미래성장지원(드",
    "finalYn": "Y",
    "sortOrder": 7490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401028",
    "projectName": "인재육성 미래성장지원사업(2025년 겨울 다채로운 다문화캠프 다다캠프)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401029",
    "projectName": "인재육성 미래성장지원사업(소외지역 금융체험교실 5차년도)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401030",
    "projectName": "인재육성 미래성장지원사업 (에듀케어존 4차)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401031",
    "projectName": "인재육성 미래성장지원사업(2025년 여름 다다캠프)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401032",
    "projectName": "인재육성 미래성장지원사업(다다 브릿지)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401033",
    "projectName": "인재육성미래성장지원사업(시설입소아동지원)",
    "abbrName": "인재육성미래성장",
    "finalYn": "Y",
    "sortOrder": 7550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401034",
    "projectName": "아동 문화예술지원사업(파랑새합창단)",
    "abbrName": "아동 문화예술지",
    "finalYn": "Y",
    "sortOrder": 7560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401035",
    "projectName": "인재육성 미래성장지원사업(실력쑥쑥 재능 UP)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401036",
    "projectName": "인재육성 미래성장지원사업(좋은이웃 장학금)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401037",
    "projectName": "인재육성 미래성장지원사업(GN학원비 지원사업)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401038",
    "projectName": "인재육성 미래성장지원사업(청소년 암예방 \"Happy Virus\" 프로그램 교육)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401039",
    "projectName": "인재육성 미래성장지원사업 (삼성전기(주) 나눔키오스크)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401040",
    "projectName": "아동 문화예술지원사업(다함께 행복ON)",
    "abbrName": "아동 문화예술지",
    "finalYn": "Y",
    "sortOrder": 7620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401041",
    "projectName": "인재육성 미래성장지원사업(캠프)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401042",
    "projectName": "인재육성 미래성장지원사업(전북특별자치도 유소년 '꿈차는' 축구용품 지원사업)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401043",
    "projectName": "인재육성 미래성장지원사업(진로특화사업)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401044",
    "projectName": "인재육성 미래성장지원사업(해피빈 중등수학CLASS)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401045",
    "projectName": "인재육성미래성장지원사업(교육비지원)",
    "abbrName": "인재육성미래성장",
    "finalYn": "Y",
    "sortOrder": 7670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401046",
    "projectName": "인재육성 미래성장 지원사업 (DIG에어가스 장학지원사업)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401047",
    "projectName": "인재육성 미래성장지원사업(삼성전자 나눔키오스크-구미시가족센터 다문화아동지원사업)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401048",
    "projectName": "인재육성 미래성장지원사업(청소년장학금)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401049",
    "projectName": "인재육성 미래성장지원사업(2025 삼성 나눔 키오스크)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401050",
    "projectName": "인재육성 미래성장지원사업(꿈키움문화다양성교실)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401051",
    "projectName": "미래성장지원사업(코레일유통 동부본부 장학금 지원)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401052",
    "projectName": "인재육성 미래성장지원사업 (코레일유통(주) 아동권리옹호 장학기금)",
    "abbrName": "인재육성 미래성",
    "finalYn": "Y",
    "sortOrder": 7740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401053",
    "projectName": "미래성장지원사업(성동좋은이웃지역아동센터 문화체험지원)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401054",
    "projectName": "미래성장지원사업(우리들은 행복해 6차)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401055",
    "projectName": "미래성장지원사업(드림하이 9차)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401056",
    "projectName": "미래성장지원사업(소외지역 금융체험교실 6차)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401057",
    "projectName": "미래성장지원사업 (2026 에듀케어존 5차)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401058",
    "projectName": "미래성장지원사업(학교 밖 청소년 자립지원사업)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401059",
    "projectName": "미래성장지원사업(포스코 재능봉사단 멘토링 사업)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401060",
    "projectName": "미래성장지원사업(2026년 아동문화예술지원사업 '파랑새 합창단')",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401061",
    "projectName": "지역유치기금(미래성장 및 자립지원사업)",
    "abbrName": "지역유치기금(미",
    "finalYn": "Y",
    "sortOrder": 7830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401062",
    "projectName": "미래성장지원사업(장학지원-미래토닥)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401063",
    "projectName": "미래성장지원사업(다함께행복ON)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401064",
    "projectName": "미래성장지원사업(코레일유통 대학생 장학연계 지원사업)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0401",
    "projectCode": "0401065",
    "projectName": "미래성장지원사업(한국지역난방공사 AI인성교육 지원사업)",
    "abbrName": "미래성장지원사업",
    "finalYn": "Y",
    "sortOrder": 7870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "04",
    "projectCode": "0402",
    "projectName": "자립 지원",
    "abbrName": "자립 지원",
    "finalYn": "N",
    "sortOrder": 7880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402001",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 7890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402002",
    "projectName": "자립 지원-양육시설 금융교육(신한은행)",
    "abbrName": "자립 지원-양육",
    "finalYn": "Y",
    "sortOrder": 7900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402003",
    "projectName": "자립 지원-우리사이(우리금융미래재단)",
    "abbrName": "자립 지원-우리",
    "finalYn": "Y",
    "sortOrder": 7910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402004",
    "projectName": "자립 지원-자립캠페인(온라인캠페인)",
    "abbrName": "자립 지원-자립",
    "finalYn": "Y",
    "sortOrder": 7920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402005",
    "projectName": "자립 지원-We풍당당키트2차(우리금융미래재단)",
    "abbrName": "자립 지원-We",
    "finalYn": "Y",
    "sortOrder": 7930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402006",
    "projectName": "자립 지원-자립준비청년지원사업(현대캐피탈)",
    "abbrName": "자립 지원-자립",
    "finalYn": "Y",
    "sortOrder": 7940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402007",
    "projectName": "자립지원-우리사이2차(우리금융미래재단)",
    "abbrName": "자립지원-우리사",
    "finalYn": "Y",
    "sortOrder": 7950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402008",
    "projectName": "자립지원-JB와 열여덟 함께서기 시즌2(전북은행)",
    "abbrName": "자립지원-JB와",
    "finalYn": "Y",
    "sortOrder": 7960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402009",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(청년책빵사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 7970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402010",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(드림 ON 프로젝트-안아드림)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 7980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402011",
    "projectName": "자립지원-자립지원사업(개인후원)",
    "abbrName": "자립지원-자립지",
    "finalYn": "Y",
    "sortOrder": 7990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402012",
    "projectName": "자립지원-GN청년자문단(사단법인굿네이버스)",
    "abbrName": "자립지원-GN청",
    "finalYn": "Y",
    "sortOrder": 8000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402013",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(새만금 AI 한바퀴-A.I Basic)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402014",
    "projectName": "자립지원-자립지원사업(전북개발공사)",
    "abbrName": "자립지원-자립지",
    "finalYn": "Y",
    "sortOrder": 8020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402015",
    "projectName": "자립지원-청년의날옹호활동(자립준비청년기부금)",
    "abbrName": "자립지원-청년의",
    "finalYn": "Y",
    "sortOrder": 8030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402016",
    "projectName": "자립지원-자립준비청년비전장학금지원(지파운데이션)",
    "abbrName": "자립지원-자립준",
    "finalYn": "Y",
    "sortOrder": 8040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402017",
    "projectName": "자립지원-KDN IT We로(한전KDN)",
    "abbrName": "자립지원-KDN",
    "finalYn": "Y",
    "sortOrder": 8050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402018",
    "projectName": "자립지원-여성자립준비청년 키트 지원사업 소녀들이 WON하는 대로 시즌2(우리카드)",
    "abbrName": "자립지원-여성자",
    "finalYn": "Y",
    "sortOrder": 8060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402019",
    "projectName": "자립지원-Good건하게 (신한은행)",
    "abbrName": "자립지원-Goo",
    "finalYn": "Y",
    "sortOrder": 8070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402020",
    "projectName": "자립지원-자립준비청년장학지원사업(굿피플)",
    "abbrName": "자립지원-자립준",
    "finalYn": "Y",
    "sortOrder": 8080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402021",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(가정위탁아동자립준비학교)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402022",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402023",
    "projectName": "자립지원(자립준비청년 맞춤형 지원 사업)",
    "abbrName": "자립지원(자립준",
    "finalYn": "Y",
    "sortOrder": 8110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402024",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립쟁이우리들)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402025",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(의료비지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402026",
    "projectName": "자립준비청년 및 보호아동 자립 역량강화지원사업(우리사이 3차)-우리금융미래재단",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402027",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(드림블루밍)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402028",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(함께서기-WITH)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402029",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB희망의 아우름 멘토링 시즌1)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402030",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(청아아파트 거주 자립준비청년 주거환경 조성지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402031",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB희망의 학습멘토링 2기)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402032",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립준비청년 사회정서적 자립지원 및 기후위기식물보존사업 '지켜봐요 우리의 숲')",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402033",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립준비청년 지원 캠페인 '그린 하이')",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402034",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(위풍당당키트 3차년도)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402035",
    "projectName": "자립준비청년 및 보호아동 자립 역량강화지원사업(Trust on 시즌3)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402036",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(드림 ON 프로젝트-열어드림)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402037",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(드림 ON 프로젝트-잡아드림)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402038",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(새만금 AI 한바퀴-A.I Plus)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402039",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(새만금 AI 한바퀴-멘토링)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402040",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB희망의 학습멘토링 3기)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402041",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB와 열여덟 함께서기 시즌3-금융경제교육)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402042",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB와 열여덟 함께서기 시즌3-생필품 키트)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402043",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB와 열여덟 함께서기 시즌3-주거생활비)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402044",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB와 열여덟 함께서기 시즌3-의료비)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402045",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB와 열여덟 함께서기 시즌3-JB희망의 아우름 멘토링)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402046",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(현대자동차-올림픽 전북픽 자립픽)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402047",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(현대자동차-문화체험지원사업 '다가치, 점프')",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402048",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(현대자동차-해외문화체험지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402049",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(현대자동차 바람개비 서포터즈)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402050",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(현대자동차 운영비)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402051",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(양육시설 금융교육3차)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402052",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402053",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(개인후원자-비지정후원금)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402054",
    "projectName": "자립준비청년 및 보호아동 자립 역량강화지원사업(함께 서기 프로젝트)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402055",
    "projectName": "자립준비청년 및 보호아동 자립 역량강화지원사업(자립청년금융교육)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402056",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(보호아동지원)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402057",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(보호아동 미래성장지원사업-꿈지락 프로젝트)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402058",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(현대자동차-고유사업비)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402059",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립캠프)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402060",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(전북대학교여교수회장학금지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402061",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB와 열여덟 함께서기 시즌1-의료비)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402062",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(여성 자립준비청년 모성보호지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402063",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(2025년 청년의 날 기념 옹호활동 일일찻집-가정위탁아동지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402064",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(지역아동센터 자원봉사(학습멘토링) 자립준비청년 장학지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402065",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(LH자립준비청년 생활지원 사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402066",
    "projectName": "자립준비청년 및 보호아동자립역량강화지원사업(ALL I 프로젝트)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402067",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(온자립)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402068",
    "projectName": "자립준비청년 및 보호아동 자립 역량강화지원사업(우리사이 4차)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402069",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(2026 우리찬스자립키트 4차년도)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402070",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(희망디딤돌)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402071",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(only 온)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402072",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB희망의 학습멘토링 4기)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402073",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB자립플랜 프로젝트-금융경제교육)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402074",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB자립플랜 프로젝트-주거생활비 지원)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402075",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB자립플랜 프로젝트-의료비 지원)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402076",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB자립플랜 프로젝트-학습비 지원)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402077",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(JB자립플랜 프로젝트-JB희망의 아우름 멘토링)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402078",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립준비청년 성장지원사업-RISE 청년 스타트)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402079",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(현대자동차-찾아가는 자립트럭)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402080",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(ON자립)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402081",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(여름철 에너지 자립생활안정 지원사업)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0402",
    "projectCode": "0402082",
    "projectName": "자립준비청년 및 보호아동 자립역량강화지원사업(자립준비청년 건강권 보장 의식주지원사업-자립애 : 온)",
    "abbrName": "자립준비청년 및",
    "finalYn": "Y",
    "sortOrder": 8700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "05",
    "projectName": "아동권리옹호",
    "abbrName": "아동권리옹호",
    "finalYn": "N",
    "sortOrder": 8710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "05",
    "projectCode": "0501",
    "projectName": "아동권리옹호",
    "abbrName": "아동권리옹호",
    "finalYn": "N",
    "sortOrder": 8720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501001",
    "projectName": "아동권리 교육",
    "abbrName": "아동권리 교육",
    "finalYn": "Y",
    "sortOrder": 8730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501002",
    "projectName": "아동권리캠페인(인식/제도개선)",
    "abbrName": "아동권리캠페인(",
    "finalYn": "Y",
    "sortOrder": 8740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501003",
    "projectName": "아동권리캠페인(인식/제도개선)(한국아동단체협의회 대한민국아동총회)",
    "abbrName": "아동권리캠페인(",
    "finalYn": "Y",
    "sortOrder": 8750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501004",
    "projectName": "아동참여증진(전북특별자치도 완주군 아동 사회통합 및 자존감 향상 지원사업 '완주 아동이음합창단')",
    "abbrName": "아동참여증진(전",
    "finalYn": "Y",
    "sortOrder": 8760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501005",
    "projectName": "아동권리 캠페인-아동청소년 돌봄강화 프로그램(공동모금회)",
    "abbrName": "아동권리 캠페인",
    "finalYn": "Y",
    "sortOrder": 8770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501006",
    "projectName": "아동권리옹호(지역사회 아동학대 예방 헌혈캠페인)",
    "abbrName": "아동권리옹호(지",
    "finalYn": "Y",
    "sortOrder": 8780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501007",
    "projectName": "아동권리옹호(아동참여위원회-아동권리증진을 위한 교육 및 참여활동사업(더욱 THE 반짝 PART2))",
    "abbrName": "아동권리옹호(아",
    "finalYn": "Y",
    "sortOrder": 8790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501008",
    "projectName": "아동권리옹호(아동권리동화책제작-아동권리증진을 위한 교육 및 참여활동사업(더욱 THE 반짝 PART2))",
    "abbrName": "아동권리옹호(아",
    "finalYn": "Y",
    "sortOrder": 8800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501009",
    "projectName": "아동권리옹호(중구야 우리도 같이가자)",
    "abbrName": "아동권리옹호(중",
    "finalYn": "Y",
    "sortOrder": 8810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501010",
    "projectName": "아동권리옹호 (대학생교육 굿워크)",
    "abbrName": "아동권리옹호 (",
    "finalYn": "Y",
    "sortOrder": 8820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501011",
    "projectName": "아동권리옹호(굿러너컴퍼니)",
    "abbrName": "아동권리옹호(굿",
    "finalYn": "Y",
    "sortOrder": 8830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501012",
    "projectName": "아동권리옹호(대국민캠페인 건강권-지금움직여봐)",
    "abbrName": "아동권리옹호(대",
    "finalYn": "Y",
    "sortOrder": 8840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501013",
    "projectName": "아동참여증진",
    "abbrName": "아동참여증진",
    "finalYn": "Y",
    "sortOrder": 8850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501014",
    "projectName": "아동권리캠페인(인식/제도개선)(일반사업)",
    "abbrName": "아동권리캠페인(",
    "finalYn": "Y",
    "sortOrder": 8860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501015",
    "projectName": "아동권리캠페인(인식/제도개선)(포항/운영지원)",
    "abbrName": "아동권리캠페인(",
    "finalYn": "Y",
    "sortOrder": 8870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501016",
    "projectName": "아동권리캠페인(아동학대예방사업)",
    "abbrName": "아동권리캠페인(",
    "finalYn": "Y",
    "sortOrder": 8880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501017",
    "projectName": "아동참여증진(아동학대예방사업)",
    "abbrName": "아동참여증진(아",
    "finalYn": "Y",
    "sortOrder": 8890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501018",
    "projectName": "아동권리캠페인(인식/제도개선)(지역사회 인식개선 캠페인 '아동학대 예방 서포트 커피차')",
    "abbrName": "아동권리캠페인(",
    "finalYn": "Y",
    "sortOrder": 8900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501019",
    "projectName": "아동권리교육(전북 인권 라이트(Light) 프로젝트 '올-라이트(All-Right) 캠페인')",
    "abbrName": "아동권리교육(전",
    "finalYn": "Y",
    "sortOrder": 8910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501020",
    "projectName": "아동참여증진(2026년 아동친화도시 어린이날 대축제 딩동! Safe Kids 골든벨)",
    "abbrName": "아동참여증진(2",
    "finalYn": "Y",
    "sortOrder": 8920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501021",
    "projectName": "아동참여증진(2026년 아동친화도시 어린이날 대축제 '완주에서 JUMP! 새로운 미래를 향하여')",
    "abbrName": "아동참여증진(2",
    "finalYn": "Y",
    "sortOrder": 8930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501022",
    "projectName": "아동권리교육(2026년 아동학대예방교육(유아성폭력예방인형극) '내 몸, 내 마음은 내가 지켜요.')",
    "abbrName": "아동권리교육(2",
    "finalYn": "Y",
    "sortOrder": 8940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501023",
    "projectName": "아동참여증진(횡성군 아동참여위원회-아동권리모니터링단)",
    "abbrName": "아동참여증진(횡",
    "finalYn": "Y",
    "sortOrder": 8950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0501",
    "projectCode": "0501024",
    "projectName": "아동참여증진(코레일유통 대학생 장학연계 아동권리옹호캠페인 지원사업)",
    "abbrName": "아동참여증진(코",
    "finalYn": "Y",
    "sortOrder": 8960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "06",
    "projectName": "지속가능한 사회환경 조성",
    "abbrName": "지속가능한 사회",
    "finalYn": "N",
    "sortOrder": 8970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "06",
    "projectCode": "0601",
    "projectName": "지역사회 지원",
    "abbrName": "지역사회 지원",
    "finalYn": "N",
    "sortOrder": 8980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601001",
    "projectName": "지역사회지원사업",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 8990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601002",
    "projectName": "지역사회복지사업",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601003",
    "projectName": "지역유치기금(지역사회지원)",
    "abbrName": "지역유치기금(지",
    "finalYn": "Y",
    "sortOrder": 9010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601004",
    "projectName": "지역사회 지원-SOL Guard(신한금융그룹)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601005",
    "projectName": "지역사회 지원-명품집(한국토지주택공사)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601006",
    "projectName": "지역사회 지원-우리함께2차(우리금융그룹)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601007",
    "projectName": "지역사회지원-2024 학업장학사업(우리다문화장학재단)",
    "abbrName": "지역사회지원-2",
    "finalYn": "Y",
    "sortOrder": 9050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601008",
    "projectName": "지역사회 지원-희망틔움 통합지원단(광주경찰청)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601009",
    "projectName": "지역사회지원사업(다자녀다함께행복프로젝트)",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 9070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601010",
    "projectName": "지역사회 지원-봄봄봄 통합지원단(전남경찰청)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601011",
    "projectName": "지역사회지원-명품집(LH한국토지주택공사)",
    "abbrName": "지역사회지원-명",
    "finalYn": "Y",
    "sortOrder": 9090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601012",
    "projectName": "산책길마켓-영화산책 사업(지역사회 지원)",
    "abbrName": "산책길마켓-영화",
    "finalYn": "Y",
    "sortOrder": 9100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601013",
    "projectName": "지역사회 지원-청소년 주거환경 개선사업(한국씨티은행)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601014",
    "projectName": "지역사회지원 - 지역사회보호뇌혈관 등 긴급환자 병원이송처치 \"원스톱\" 앱 구축 및 취약계층가정 의료비 지원 사업(뷰티크리에이터 조효진)",
    "abbrName": "지역사회지원 -",
    "finalYn": "Y",
    "sortOrder": 9120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601015",
    "projectName": "지역사회지원-희망틔움 통합지원단(슬기로운재활의학과병원)",
    "abbrName": "지역사회지원-희",
    "finalYn": "Y",
    "sortOrder": 9130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601016",
    "projectName": "지역사회지원-따뜻한 주거복지 포인트(LH 광주전남지역본부)",
    "abbrName": "지역사회지원-따",
    "finalYn": "Y",
    "sortOrder": 9140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601017",
    "projectName": "지역사회지원-진로탐색프로그램 꿈을 꾸물(공동모금회)",
    "abbrName": "지역사회지원-진",
    "finalYn": "Y",
    "sortOrder": 9150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601018",
    "projectName": "지역사회지원-지정후원금(현대자동차 아산공장)",
    "abbrName": "지역사회지원-지",
    "finalYn": "Y",
    "sortOrder": 9160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601019",
    "projectName": "지역사회지원-주거지원사업 '더 좋은 HOUSE'(북극성)",
    "abbrName": "지역사회지원-주",
    "finalYn": "Y",
    "sortOrder": 9170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601020",
    "projectName": "지역사회지원-서비스연계(금비 -아산공장)",
    "abbrName": "지역사회지원-서",
    "finalYn": "Y",
    "sortOrder": 9180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601021",
    "projectName": "지역사회지원-SOS복지지원사업 서비스연계(아산시사회복지재단)",
    "abbrName": "지역사회지원-S",
    "finalYn": "Y",
    "sortOrder": 9190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601022",
    "projectName": "지역사회지원-지정후원금(좋은이웃후원회)",
    "abbrName": "지역사회지원-지",
    "finalYn": "Y",
    "sortOrder": 9200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601023",
    "projectName": "자립지원-한화자산운용 자립지원(한화자산운용)",
    "abbrName": "자립지원-한화자",
    "finalYn": "Y",
    "sortOrder": 9210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601024",
    "projectName": "지역사회지원-희망온 난방비(한국지역난방공사)",
    "abbrName": "지역사회지원-희",
    "finalYn": "Y",
    "sortOrder": 9220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601025",
    "projectName": "지역사회지원-우리사이2차(우리금융미래재단)",
    "abbrName": "지역사회지원-우",
    "finalYn": "Y",
    "sortOrder": 9230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601026",
    "projectName": "지역사회지원-자율방재단사업(한국전기안전공사)",
    "abbrName": "지역사회지원-자",
    "finalYn": "Y",
    "sortOrder": 9240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601027",
    "projectName": "지역사회 지원-With 우리 드림 up 프로젝트(우리금융그룹)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601028",
    "projectName": "지역사회 지원-안심마을조성사업(한전KPS)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601029",
    "projectName": "지역사회지원-상상나눔 On 情(KT&G)",
    "abbrName": "지역사회지원-상",
    "finalYn": "Y",
    "sortOrder": 9270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601030",
    "projectName": "지역사회 지원-취약계층 어르신 겨울나기 지원사업(한국전력거래소)",
    "abbrName": "지역사회 지원-",
    "finalYn": "Y",
    "sortOrder": 9280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601031",
    "projectName": "지역사회지원- 취약계층 주거개선 지원사업(한국철도공사)",
    "abbrName": "지역사회지원- ",
    "finalYn": "Y",
    "sortOrder": 9290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601032",
    "projectName": "지역사회약자지원사업(2025 겨울 다다캠프-중등)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601033",
    "projectName": "지역사회약자지원(신한은행-솔선수범 시즌4)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601034",
    "projectName": "지역사회약자지원사업(불특정다수모금 건)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601035",
    "projectName": "지역사회약자지원사업(호국영웅주거환경개선)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601036",
    "projectName": "지역사회약자지원사업(마음위로 힐링캠프)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601037",
    "projectName": "은둔·고립가정지원사업(마음쉼표)",
    "abbrName": "은둔·고립가정지",
    "finalYn": "Y",
    "sortOrder": 9350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601038",
    "projectName": "지역사회약자지원(보이스피싱제로 2차년도)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601039",
    "projectName": "지역사회약자지원(보이스피싱제로 3차년도)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601040",
    "projectName": "지역사회약자지원사업- '따뜻한 동행, 행복나눔 프로젝트' (팬택씨앤아이)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601041",
    "projectName": "지역사회약자지원사업(행복동행키트 시즌4)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601042",
    "projectName": "지역사회약자지원사업(구미중앙로타리클럽 기자재 지원 사업)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601043",
    "projectName": "지역사회약자지원사업(SK실트론·경북사회복지공동모금회 행복드림)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601044",
    "projectName": "지역사회약자지원사업(iM사회공헌재단 어린이안전우산 지원사업)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601045",
    "projectName": "지역사회지원사업(산책길마켓 영화산책)",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 9430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601046",
    "projectName": "지역사회약자지원사업(무료경로식당 전기간선공사)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601047",
    "projectName": "지역사회약자지원사업(다문화가정 환경개선)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601048",
    "projectName": "지역사회약자지원사업(쪽방촌지원사업)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601049",
    "projectName": "기후위기대응사업(햇살가득 꿈가득)",
    "abbrName": "기후위기대응사업",
    "finalYn": "Y",
    "sortOrder": 9470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601050",
    "projectName": "지역사회약자지원사업(똑똑자동차)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601051",
    "projectName": "지역사회약자지원사업(마을잔치)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601052",
    "projectName": "지역사회약자지원사업(좋은이웃후원회)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601053",
    "projectName": "지역사회약자지원사업(시니어산들바람학교)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601054",
    "projectName": "지역사회약자지원사업(어르신연합회 은행나무합창단)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601055",
    "projectName": "지역사회약자지원사업(지하철모금사업)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601056",
    "projectName": "사회적약자지원사업(희망온돌긴급지원)",
    "abbrName": "사회적약자지원사",
    "finalYn": "Y",
    "sortOrder": 9540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601057",
    "projectName": "지역사회약자지원사업(결연후원금)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601058",
    "projectName": "지역사회약자지원사업 (마음건강지킴이 Good Friend 3차)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601059",
    "projectName": "지역사회지원사업(이재민 주거복구 지원사업 3차년도)",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 9570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601060",
    "projectName": "지역사회약자지원사업(서비스연계_사회복지공동모금회)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601061",
    "projectName": "지역사회약자지원(우리손으로만드는건강)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601062",
    "projectName": "지역사회약자지원사업(차량지원사업)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601063",
    "projectName": "지역사회약자지원사업(서비스연계_함꼐하는사랑밭)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601064",
    "projectName": "지역사회약자지원사업(서비스연계_세이브더칠드런)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601065",
    "projectName": "지역사회약자지원사업(서비스연계_KDB나눔재단)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601066",
    "projectName": "지역사회약자지원사업(우리동네 안전거울)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601067",
    "projectName": "지역사회약자지원사업(추석 명절 어르신 지원)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601068",
    "projectName": "지역사회약자지원사업(태백지역 에너지빈곤층가정 연탄지원사업 '온기로운 겨울생활')",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601069",
    "projectName": "지역사회복지사업 (우리카드와 함께하는 사랑의 김장나눔)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601070",
    "projectName": "지역사회약자지원사업(금융안전 지킴이상)",
    "abbrName": "지역사회약자지원",
    "finalYn": "Y",
    "sortOrder": 9680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601071",
    "projectName": "범죄피해아동 및 가정지원사업(2026년 겨울 다다캠프)",
    "abbrName": "범죄피해아동 및",
    "finalYn": "Y",
    "sortOrder": 9690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601072",
    "projectName": "범죄피해아동 및 가정지원사업(서민경제수호영웅상)",
    "abbrName": "범죄피해아동 및",
    "finalYn": "Y",
    "sortOrder": 9700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601073",
    "projectName": "지역사회지원사업(Dear Young 3차년도)",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 9710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601074",
    "projectName": "범죄피해아동 및 가정지원사업(굿세이프디지털안심마을)",
    "abbrName": "범죄피해아동 및",
    "finalYn": "Y",
    "sortOrder": 9720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601075",
    "projectName": "이주배경아동지원사업(한입가득한국)",
    "abbrName": "이주배경아동지원",
    "finalYn": "Y",
    "sortOrder": 9730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601076",
    "projectName": "은둔·고립 가정 지원사업",
    "abbrName": "은둔·고립 가정",
    "finalYn": "Y",
    "sortOrder": 9740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601077",
    "projectName": "이주배경아동 지원사업",
    "abbrName": "이주배경아동 지",
    "finalYn": "Y",
    "sortOrder": 9750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601078",
    "projectName": "범죄피해아동 및 가정지원사업",
    "abbrName": "범죄피해아동 및",
    "finalYn": "Y",
    "sortOrder": 9760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601079",
    "projectName": "지역사회복지사업(비지정후원금)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601080",
    "projectName": "지역사회복지사업(기타수익사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601081",
    "projectName": "지역사회복지사업(법인전입금(후원금))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601082",
    "projectName": "지역사회복지사업(직무수당)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601083",
    "projectName": "지역사회복지사업(종사자 건강검진비)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601084",
    "projectName": "지역사회복지사업(경상보조금(운영비))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601085",
    "projectName": "지역사회복지사업(바우처-아동청소년심리지원서비스)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601086",
    "projectName": "지역사회복지사업(저소득보훈가족밑반찬지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601087",
    "projectName": "지역사회복지사업(경상보조금(인건비))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601088",
    "projectName": "지역사회복지사업(이웃사이 프로젝트 온에어)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601089",
    "projectName": "지역사회복지사업(직원중식비)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601090",
    "projectName": "지역사회복지사업(출산축하금)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601091",
    "projectName": "지역사회복지사업(장애인근로자인건비)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601092",
    "projectName": "지역사회복지사업(시니어산들바람학교)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601093",
    "projectName": "지역사회복지사업(어르신연합회 은행나무합창단)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601094",
    "projectName": "지역사회복지사업(지하철모금사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601095",
    "projectName": "지역사회복지사업(청소년장학금)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601096",
    "projectName": "지역사회복지사업(마을잔치후원금)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601097",
    "projectName": "지역사회복지사업(희망온돌긴급지원)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601098",
    "projectName": "지역사회복지사업(해뜰작은도서관)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601099",
    "projectName": "지역사회복지사업(무료급식사업 밑반찬배달)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601100",
    "projectName": "지역사회복지사업(급식지원사업운영비(식사배달))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601101",
    "projectName": "지역사회복지사업(식사배달)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 9990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601102",
    "projectName": "지역사회복지사업(지역밀착형사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601103",
    "projectName": "지역사회복지사업(경로식당)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10010
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601104",
    "projectName": "지역사회복지사업(난방비지원금(강서구))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10020
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601105",
    "projectName": "지역사회복지사업(강서구 맞춤형복지포인트)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10030
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601106",
    "projectName": "지역사회복지사업(시설개방)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10040
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601107",
    "projectName": "지역사회복지사업(노인기능특화)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10050
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601108",
    "projectName": "지역사회복지사업(복지관보조금(운영비))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10060
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601109",
    "projectName": "지역사회복지사업(서울시 종사자복지포인트)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10070
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601110",
    "projectName": "지역사회복지사업(비정규직처우개선비)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10080
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601111",
    "projectName": "지역사회복지사업(복지관보조금(인건비))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10090
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601112",
    "projectName": "지역사회복지사업(특수교육지원센터치료지원)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10100
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601113",
    "projectName": "지역사회복지사업(고독사 예방 및 관리지원(e나라))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10110
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601114",
    "projectName": "지역사회복지사업(아발센터이용자)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10120
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601115",
    "projectName": "지역사회복지사업(종사자 복지포인트)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10130
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601116",
    "projectName": "지역사회복지사업(성인심리지원서비스사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10140
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601117",
    "projectName": "지역사회복지사업(복지수당)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10150
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601118",
    "projectName": "지역사회복지사업(행복가득백년청춘)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10160
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601119",
    "projectName": "지역사회복지사업(장애인 여가지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10170
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601120",
    "projectName": "지역사회복지사업(송악면 행복키움추진단)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10180
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601121",
    "projectName": "지역사회복지사업(온양6동 행복키움추진단)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10190
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601122",
    "projectName": "지역사회복지사업(온양2동 행복키움추진단)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10200
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601123",
    "projectName": "지역사회복지사업(온양5동 행복키움추진단)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10210
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601124",
    "projectName": "지역사회복지사업(사례관리사)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10220
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601125",
    "projectName": "지역사회복지사업(무료식사배달(도시락배달))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10230
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601126",
    "projectName": "지역사회복지사업(무료경로식당(한끼나눔))",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10240
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601127",
    "projectName": "지역사회복지사업(어르신복지기금)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10250
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601128",
    "projectName": "지역사회복지사업(기능보강사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10260
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601129",
    "projectName": "지역사회복지사업(장애인평생학습도시)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10270
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601130",
    "projectName": "지역사회복지사업(결연후원금)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10280
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601131",
    "projectName": "은둔·고립가정 지원사업(똑똑자동차)",
    "abbrName": "은둔·고립가정 ",
    "finalYn": "Y",
    "sortOrder": 10290
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601132",
    "projectName": "지역사회복지사업(KB자산운용)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10300
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601133",
    "projectName": "지역사회복지사업(디지털신체활동VR)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10310
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601134",
    "projectName": "지역사회복지사업(좋은이웃후원회)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10320
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601135",
    "projectName": "지역사회복지사업(공동모금회여아지원사업반짝반짝)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10330
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601136",
    "projectName": "지역사회복지사업(신한금융희망재단)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10340
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601137",
    "projectName": "지역사회복지사업(지역사회복지지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10350
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601138",
    "projectName": "지역사회복지사업(진로탐색프로그램 꿈을꾸물)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10360
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601139",
    "projectName": "지역사회복지사업(사례관리직능단체긴급지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10370
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601140",
    "projectName": "지역사회복지사업(공동모금회 차량지원)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10380
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601141",
    "projectName": "지역사회복지사업(현대자동차 지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10390
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601142",
    "projectName": "지역사회복지사업(북극성 주거지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10400
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601143",
    "projectName": "지역사회복지사업(사례가정지원-온주)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10410
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601144",
    "projectName": "지역사회복지사업(취약계층 아동청소년 신학기 지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10420
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601145",
    "projectName": "지역사회지원사업(우리함께 4차)",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 10430
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601146",
    "projectName": "지역유치기금(지역사회지원사업)",
    "abbrName": "지역유치기금(지",
    "finalYn": "Y",
    "sortOrder": 10440
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601147",
    "projectName": "지역유치기금(은둔·고립가정지원사업)",
    "abbrName": "지역유치기금(은",
    "finalYn": "Y",
    "sortOrder": 10450
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601148",
    "projectName": "지역유치기금(이주배경아동지원사업)",
    "abbrName": "지역유치기금(이",
    "finalYn": "Y",
    "sortOrder": 10460
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601149",
    "projectName": "지역유치기금(범죄피해아동 및 가정지원사업)",
    "abbrName": "지역유치기금(범",
    "finalYn": "Y",
    "sortOrder": 10470
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601150",
    "projectName": "지역사회복지사업(2026설명절지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10480
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601151",
    "projectName": "지역사회복지사업(꿈날개클럽)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10490
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601152",
    "projectName": "지역사회복지사업(가배도-자립청년지원)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10500
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601153",
    "projectName": "범죄피해아동 및 가정지원사업(범죄피해 및 취약가정 지원사업 '사회적약자 보호·지원 공동대응협의체')",
    "abbrName": "범죄피해아동 및",
    "finalYn": "Y",
    "sortOrder": 10510
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601154",
    "projectName": "이주배경아동지원사업(교육지원사업- 다함께성장ON)",
    "abbrName": "이주배경아동지원",
    "finalYn": "Y",
    "sortOrder": 10520
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601155",
    "projectName": "지역사회복지사업(iM HAPPY DAY)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10530
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601156",
    "projectName": "지역사회복지사업(여송재단 문화예술지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10540
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601157",
    "projectName": "지역사회복지사업(방화마을구순잔치)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10550
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601158",
    "projectName": "지역사회복지사업(경로식당 도시가스 변경 공사 사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10560
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601159",
    "projectName": "지역사회복지사업(노인상생복지지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10570
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601160",
    "projectName": "지역사회복지사업(상생복지지원사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10580
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601161",
    "projectName": "지역사회지원사업(임팩트사업지원)",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 10590
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601162",
    "projectName": "지역사회지원사업(아동학대예방 인식확산 공익음원 프로젝트 'IEUM UP')",
    "abbrName": "지역사회지원사업",
    "finalYn": "Y",
    "sortOrder": 10600
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601163",
    "projectName": "지역사회복지사업(강서구 고립·은둔 가구 사회연결 회복지원 사업)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10610
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601164",
    "projectName": "지역사회복지사업(iM HAPPY DAY-시원한 선물)",
    "abbrName": "지역사회복지사업",
    "finalYn": "Y",
    "sortOrder": 10620
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0601",
    "projectCode": "0601165",
    "projectName": "범죄피해아동 및 가정지원사업(2026년 여름 다다캠프)",
    "abbrName": "범죄피해아동 및",
    "finalYn": "Y",
    "sortOrder": 10630
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "07",
    "projectName": "아동권리연구사업",
    "abbrName": "아동권리연구사업",
    "finalYn": "N",
    "sortOrder": 10640
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "07",
    "projectCode": "0701",
    "projectName": "아동권리연구사업",
    "abbrName": "아동권리연구사업",
    "finalYn": "N",
    "sortOrder": 10650
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0701",
    "projectCode": "0701001",
    "projectName": "아동권리보호연구사업",
    "abbrName": "아동권리보호연구",
    "finalYn": "Y",
    "sortOrder": 10660
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "07",
    "projectCode": "0702",
    "projectName": "정책연구사업",
    "abbrName": "정책연구사업",
    "finalYn": "N",
    "sortOrder": 10670
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0702",
    "projectCode": "0702001",
    "projectName": "정책연구사업",
    "abbrName": "정책연구사업",
    "finalYn": "Y",
    "sortOrder": 10680
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "08",
    "projectName": "네트워크 강화와 성장동력 마련",
    "abbrName": "네트워크 강화와",
    "finalYn": "N",
    "sortOrder": 10690
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "08",
    "projectCode": "0801",
    "projectName": "네트워크 강화와 성장동력 마련",
    "abbrName": "네트워크 강화와",
    "finalYn": "N",
    "sortOrder": 10700
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0801",
    "projectCode": "0801001",
    "projectName": "모금관리비",
    "abbrName": "모금관리비",
    "finalYn": "Y",
    "sortOrder": 10710
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "09",
    "projectName": "사회복지법인 및 시설 운영",
    "abbrName": "사회복지법인 및",
    "finalYn": "N",
    "sortOrder": 10720
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "09",
    "projectCode": "0901",
    "projectName": "사회복지법인 및 시설 운영",
    "abbrName": "사회복지법인 및",
    "finalYn": "N",
    "sortOrder": 10730
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "0901",
    "projectCode": "0901001",
    "projectName": "일반관리비",
    "abbrName": "일반관리비",
    "finalYn": "Y",
    "sortOrder": 10740
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "10",
    "projectName": "수증물품",
    "abbrName": "수증물품",
    "finalYn": "N",
    "sortOrder": 10750
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "10",
    "projectCode": "1001",
    "projectName": "수증물품",
    "abbrName": "수증물품",
    "finalYn": "N",
    "sortOrder": 10760
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1001",
    "projectCode": "1001001",
    "projectName": "수증물품",
    "abbrName": "수증물품",
    "finalYn": "Y",
    "sortOrder": 10770
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "11",
    "projectName": "예비비",
    "abbrName": "예비비",
    "finalYn": "N",
    "sortOrder": 10780
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "11",
    "projectCode": "1101",
    "projectName": "예비비",
    "abbrName": "예비비",
    "finalYn": "N",
    "sortOrder": 10790
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1101",
    "projectCode": "1101001",
    "projectName": "예비비",
    "abbrName": "예비비",
    "finalYn": "Y",
    "sortOrder": 10800
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1101",
    "projectCode": "1101002",
    "projectName": "지속준비사업비",
    "abbrName": "지속준비사업비",
    "finalYn": "Y",
    "sortOrder": 10810
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "12",
    "projectName": "수지외현금",
    "abbrName": "수지외현금",
    "finalYn": "N",
    "sortOrder": 10820
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "12",
    "projectCode": "1201",
    "projectName": "수지외현금",
    "abbrName": "수지외현금",
    "finalYn": "N",
    "sortOrder": 10830
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1201",
    "projectCode": "1201001",
    "projectName": "수지외현금",
    "abbrName": "수지외현금",
    "finalYn": "Y",
    "sortOrder": 10840
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "13",
    "projectName": "수입사업",
    "abbrName": "수입사업",
    "finalYn": "N",
    "sortOrder": 10850
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "13",
    "projectCode": "1301",
    "projectName": "수입사업",
    "abbrName": "수입사업",
    "finalYn": "N",
    "sortOrder": 10860
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1301",
    "projectCode": "1301001",
    "projectName": "수입사업",
    "abbrName": "수입사업",
    "finalYn": "Y",
    "sortOrder": 10870
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "14",
    "projectName": "감가상각비",
    "abbrName": "감가상각비",
    "finalYn": "N",
    "sortOrder": 10880
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "14",
    "projectCode": "1401",
    "projectName": "감가상각비 - 모금비용",
    "abbrName": "감가상각비 - ",
    "finalYn": "N",
    "sortOrder": 10890
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1401",
    "projectCode": "1401001",
    "projectName": "감가상각비 - 모금비용",
    "abbrName": "감가상각비 - ",
    "finalYn": "Y",
    "sortOrder": 10900
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "14",
    "projectCode": "1402",
    "projectName": "감가상각비 - 사업수행비용",
    "abbrName": "감가상각비 - ",
    "finalYn": "N",
    "sortOrder": 10910
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1402",
    "projectCode": "1402001",
    "projectName": "감가상각비 - 사업수행비용",
    "abbrName": "감가상각비 - ",
    "finalYn": "Y",
    "sortOrder": 10920
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "14",
    "projectCode": "1403",
    "projectName": "감가상각비 - 일반관리비용",
    "abbrName": "감가상각비 - ",
    "finalYn": "N",
    "sortOrder": 10930
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1403",
    "projectCode": "1403001",
    "projectName": "감가상각비 - 일반관리비용",
    "abbrName": "감가상각비 - ",
    "finalYn": "Y",
    "sortOrder": 10940
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "정책",
    "parentCode": "",
    "projectCode": "15",
    "projectName": "상각비",
    "abbrName": "상각비",
    "finalYn": "N",
    "sortOrder": 10950
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "15",
    "projectCode": "1501",
    "projectName": "상각비 - 모금비용",
    "abbrName": "상각비 - 모금",
    "finalYn": "N",
    "sortOrder": 10960
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1501",
    "projectCode": "1501001",
    "projectName": "상각비 - 모금비용",
    "abbrName": "상각비 - 모금",
    "finalYn": "Y",
    "sortOrder": 10970
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "15",
    "projectCode": "1502",
    "projectName": "상각비 - 사업수행비용",
    "abbrName": "상각비 - 사업",
    "finalYn": "N",
    "sortOrder": 10980
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1502",
    "projectCode": "1502001",
    "projectName": "상각비 - 사업수행비용",
    "abbrName": "상각비 - 사업",
    "finalYn": "Y",
    "sortOrder": 10990
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "단위",
    "parentCode": "15",
    "projectCode": "1503",
    "projectName": "상각비 - 일반관리비용",
    "abbrName": "상각비 - 일반",
    "finalYn": "N",
    "sortOrder": 11000
  },
  {
    "useYn": "Y",
    "budgetType": "사업예산",
    "startYear": "2026",
    "endYear": "2100",
    "inputYn": "Y",
    "fieldCode": null,
    "fieldName": "",
    "sectorCode": null,
    "sectorName": "",
    "fieldSectorNm": "",
    "budgetDeptCode": null,
    "budgetDeptNm": "",
    "remark": "GNK 사업 (세부사업.xls · 정책/단위/세부 매핑)",
    "levelName": "세부",
    "parentCode": "1503",
    "projectCode": "1503001",
    "projectName": "상각비 - 일반관리비용",
    "abbrName": "상각비 - 일반",
    "finalYn": "Y",
    "sortOrder": 11010
  }
];
